import React, { useState, useRef, useEffect, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectCards } from "swiper/modules";
import { Swiper as SwiperType } from "swiper";
import { Product, ListImages, Color, Frame, PrintPaperSize, Customer, Province, Transport, PaymentMethod } from '../../lib/Types';
import LoadingData from '../../components/loadding/LoadingData';
import { useAuthCustomer } from "../../components/hooks/useAuthCustomer";
import FormLoading from "../../components/loadding/FormLoading";
import Swal from "sweetalert2";
import Header from "../../components/layouts/Header"
import Footer from "../../components/layouts/Footer"

type ResizeDir = | "n" | "s" | "e" | "w" | "ne" | "nw" | "se" | "sw";

const Cart = () => {
    const { customer } = useAuthCustomer();
    const [quantities, setQuantities] = useState<{ [key: number]: number }>({});
    const [upload, setUpload] = useState(false);
    const [address, setAddress] = useState(false);
    const [orderConfirm, setOrderConfirm] = useState(false);
    const [pageOrderConfirm, setPageOrderConfirm] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [pageUpload, setPageUpload] = useState(true);
    const [listImageSort, setListImageSort] = useState(0);
    const [buyAlbum, setBuyAlbum] = useState(false);
    const [open, setOpen] = useState(false);
    const [openRepair, setOpenRepair] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const [payment, setPayment] = useState(false);
    const [zoom, setZoom] = useState(1);
    const [rotation, setRotation] = useState(0);
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const [isCropOpen, setIsCropOpen] = useState(false);
    const [activeOption, setActiveOption] = useState(1);
    const [optionProduct, setOptionProduct] = useState(false);
    const [product, setProduct] = useState<Product[]>([]);
    const [productDetail, setProductDetail] = useState<Product[]>([]);
    const [paymentMethod, setPaymentMethod] = useState<PaymentMethod[]>([]);
    const [localImages, setLocalImages] = useState<ListImages[]>([]);
    const [getCustomer, setGetCustomer] = useState<Customer | null>(null);
    const [getTransport, setGetTransport] = useState<Transport[]>([]);
    const [selectedImages, setSelectedImages] = useState<ListImages[]>([]);
    const [pageOrder, setPageOrder] = useState(false);
    const [sortImage, setSortImage] = useState(false);
    const swiperRef1 = useRef<SwiperType | null>(null);
    const swiperRef2 = useRef<SwiperType | null>(null);
    const swiperRef = useRef<SwiperType | null>(null);
    const swiperRef3 = useRef<SwiperType | null>(null);
    const [loadingCart, setLoadingCart] = useState(false);
    const [loadingAddress, setLoadingAddress] = useState(false);
    const [loadingProduct, setLoadingProduct] = useState(false);
    const [loadingProductDetail, setLoadingProductDetail] = useState(false);
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const folderInputRef = useRef<HTMLInputElement | null>(null);
    const [activeProductId, setActiveProductId] = useState<number | null>(null);
    const [selectColorId, setSelectColorId] = useState<number | null>(null);
    const [selectFrameId, setSelectFrameId] = useState<number | null>(null);
    const [selectSizeId, setSelectSizeId] = useState<number | null>(null);
    const [selectedColor, setSelectedColor] = useState<Color | null>(null);
    const [selectedFrame, setSelectedFrame] = useState<Frame | null>(null);
    const [selectedSize, setSelectedSize] = useState<PrintPaperSize | null>(null);
    const [activeTab, setActiveTab] = useState(1);
    const [files, setFiles] = useState<File[]>([]);
    const [images, setImages] = useState<string[]>([]);
    const MIN_SIZE = 20;
    const MIN_SCALE = 0.01;
    const MAX_SCALE = 1.5;
    const STEP = 0.02;
    const imgRef = useRef<HTMLImageElement | null>(null);
    // const [scale, setScale] = useState(1);
    // const scaled = (value: number) => value * scale;
    // const [baseScale, setBaseScale] = useState(1);
    const [userScale, setUserScale] = useState(1);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [imgLoaded, setImgLoaded] = useState(false);
    const [showLoading, setShowLoading] = useState(true);
    const [deleteMode, setDeleteMode] = useState(false);
    const [checkedImages, setCheckedImages] = useState<number[]>([]);
    const [provinces, setProvinces] = useState<Province[]>([]);
    const [provinceId, setProvinceId] = useState("");
    const [districtId, setDistrictId] = useState("");
    const [wardId, setWardId] = useState("");
    const selectedProvince = provinces.find(p => p.Id === provinceId);
    const districts = selectedProvince?.Districts || [];
    const selectedDistrict = districts.find(d => d.Id === districtId);
    const wards = selectedDistrict?.Wards || [];
    const [errors, setErrors] = useState<Record<string, string[]>>({});
    const [editingAddress, setEditingAddress] = useState<any | null>(null);
    const [selectedTransport, setSelectedTransport] = useState<any | null>(null);
    const [selectedAddressId, setSelectedAddressId] = useState<number | null>(null);
    const [selectedAddress, setSelectedAddress] = useState<any | null>(null);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any | null>(null);
    const [usePoint, setUsePoint] = useState(false); // mặc định KHÔNG sử dụng
    const [pointUsed, setPointUsed] = useState<number>(0);
    const totalPoint = Number(getCustomer?.earn_point?.point ?? 0);

    // khi xoay img
    const autoScale = useMemo(() => {
        if (!imgRef.current || !wrapperRef.current) return 1;

        const img = imgRef.current;
        const wrapper = wrapperRef.current;

        if (!img.naturalWidth || !img.naturalHeight) return 1;

        const isRotated = rotation % 180 !== 0;

        const imgWidth = isRotated ? img.naturalHeight : img.naturalWidth;
        const imgHeight = isRotated ? img.naturalWidth : img.naturalHeight;

        const scaleX = wrapper.clientWidth / imgWidth;
        const scaleY = wrapper.clientHeight / imgHeight;

        return Math.min(scaleX, scaleY, 1);
    }, [selectedIndex, rotation, imgLoaded]);

    const finalScale = autoScale * userScale;

    const [form, setForm] = useState({
        name: "",
        email: "",
        tel: "",
        password: "",
        verify_code: "",
        province: "",
        district: "",
        ward: "",
        note_address: "",
        is_default: false
    });

    const resetForm = () => {
        setForm(prev => ({
            ...prev,
            name: "",
            tel: "",
            note_address: "",
            province: "",
            district: "",
            ward: "",
            is_default: false
        }));

        setProvinceId("");
        setDistrictId("");
        setWardId("");
        setErrors({});
    };

    const increaseScale = () => {
        setUserScale(prev => Math.min(MAX_SCALE, prev + STEP));
    };

    const decreaseScale = () => {
        setUserScale(prev => Math.max(MIN_SCALE, prev - STEP));
    };

    const slides1 = [
        { id: 1, img: "/images/OrderOption/img-slide.png", store: "300", name: "Album vải lanh 1", price: 10000 },
        { id: 2, img: "/images/OrderOption/img-slide.png", store: "200", name: "Album vải lanh 2", price: 10000 },
        { id: 3, img: "/images/OrderOption/img-slide.png", store: "100", name: "Album vải lanh 3", price: 10000 },
    ];

    const slides2 = [
        { id: 1, img: "/images/OrderOption/img-demo2.png", store: "300", name: "Album 1", price: 10000 },
        { id: 2, img: "/images/OrderOption/img-demo2.png", store: "200", name: "Album 2", price: 10000 },
        { id: 3, img: "/images/OrderOption/img-demo2.png", store: "100", name: "Album 3", price: 10000 },
        { id: 4, img: "/images/OrderOption/img-demo2.png", store: "100", name: "Album 3", price: 10000 },
        { id: 5, img: "/images/OrderOption/img-demo2.png", store: "100", name: "Album 3", price: 10000 },
    ];

    const products: any[] = [
        {
            id: 1,
            name: "Album 1",
            price: 10000,
            image: "/images/OrderOption/img-demo.png",
        },
        {
            id: 2,
            name: "Album 2",
            price: 10000,
            image: "/images/OrderOption/img-demo.png",
        },
        {
            id: 3,
            name: "Album 3",
            price: 10000,
            image: "/images/OrderOption/img-demo.png",
        },
        {
            id: 4,
            name: "Album 4",
            price: 10000,
            image: "/images/OrderOption/img-demo.png",
        },
        {
            id: 5,
            name: "Album 5",
            price: 10000,
            image: "/images/OrderOption/img-demo.png",
        },
        {
            id: 6,
            name: "Album 6",
            price: 10000,
            image: "/images/OrderOption/img-demo.png",
        },
    ];

    const steps = [
        "Chỉnh sửa",
        "Tuỳ chọn sản phẩm",
        "Địa chỉ giao hàng",
        "Thanh toán",
        "Xác nhận đặt hàng",
        "Hoàn tất đặt hàng"
    ];

    const items = [
        { id: 1, store: 300, price: 10000, name: "Sản phẩm 1", img: "/images/OrderOption/img.png" },
        { id: 2, store: 1200, price: 10000, name: "Sản phẩm 2", img: "/images/OrderOption/img.png" },
        { id: 3, store: 120, price: 15000, name: "Sản phẩm 3", img: "/images/OrderOption/img.png" },
        { id: 4, store: 300, price: 20000, name: "Sản phẩm 4", img: "/images/OrderOption/img.png" },
        { id: 5, store: 300, price: 20000, name: "Sản phẩm 4", img: "/images/OrderOption/img.png" },
    ];

    const totalQuantity = selectedImages.reduce(
        (sum, img) => sum + (img.quantity ?? 1),
        0
    );

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleUpload = async () => {
        try {
            if (!customer) return;
            setLoading(true);
            const formData = new FormData();

            files.forEach((file) => {
                formData.append("images[]", file);
            });

            formData.append(
                "positions",
                JSON.stringify(
                    localImages.map((img) => img.position)
                )
            );

            const params = new URLSearchParams({
                customer_id: customer.id.toString(),
            });

            const res = await fetch(`${process.env.REACT_APP_API_URL}/cart/upload?${params.toString()}`, {
                method: "POST",
                body: formData,
            });

            const data = await res.json();

            setLoading(false);
            setUpload(false);
            setImages([]);
            setFiles([]);
            fetchCart();
            return data;
        } catch (error) {
            console.error('error');
        } finally {
            setLoading(false);
        }
    };

    const handleCrop = async () => {
        if (!customer || loading) return;

        const position = getCropData();

        if (!position) {
            // console.warn("No crop data");
            return;
        }

        setLoading(true);
        // const payload = {
        //     customer_id: customer.id,
        //     image_id: selectedImages[selectedIndex!].id,
        //     position,
        // };

        // console.log("📤 Crop payload:", payload);
        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/cart/crop`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        customer_id: customer.id,
                        image_id: selectedImages[selectedIndex!].id,
                        position,
                    }),
                }
            );

            if (!res.ok) {
                throw new Error("Crop API failed");
            }

            const data = await res.json();

            setIsCropOpen(false);
            fetchCart();
            setOptionProduct(true)

            return data;
        } catch (error) {
            console.error("Crop error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSaveOption = async () => {
        const missingOptions = [];

        if (!selectColorId) missingOptions.push('màu sắc');
        if (!selectFrameId) missingOptions.push('loại khung');
        if (!selectSizeId) missingOptions.push('kích thước');

        if (missingOptions.length > 0) {
            Swal.fire({
                icon: 'warning',
                text: `Vui lòng chọn: ${missingOptions.join(', ')}`,
                confirmButtonText: 'OK',
                confirmButtonColor: '#046DB3',
            });
            return;
        }

        setLoading(true);

        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/cart/save-option`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        image_id: selectedImages[selectedIndex!].id,
                        product_id: activeProductId,
                        color_id: selectColorId,
                        frame_id: selectFrameId,
                        size_id: selectSizeId,
                        total_amount: totalPrice,
                    }),
                }
            );

            if (!res.ok) {
                throw new Error("Save option failed");
            }

            setLoading(false);

            await Swal.fire({
                icon: "success",
                title: "Thành công",
                text: "Bạn đã chọn thành công!",
                timer: 1500,
                showConfirmButton: false,
            });

            fetchCart();
            setOptionProduct(false);

        } catch (error) {
            console.error("Save option error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateQuantity = async (
        id: number,
        quantity: number
    ): Promise<void> => {
        try {
            await fetch(`${process.env.REACT_APP_API_URL}/cart/update-quantity/${id}`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ quantity }),
            });
        } catch (error) {
            console.error("Update quantity failed", error);
        }
    };

    const fetchCart = async () => {
        try {
            if (!customer) return;

            setLoadingCart(true);

            const params = new URLSearchParams({
                customer_id: customer.id.toString(),
            });

            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/cart?${params.toString()}`
            );

            if (!res.ok) throw new Error("Fetch failed");

            const json = await res.json();
            const normalized = json.data.map((img: any) => ({
                ...img,
                position:
                    typeof img.position === "string"
                        ? JSON.parse(img.position)
                        : img.position,
            }));

            setSelectedImages(normalized);

        } catch (error) {
            console.error(error);
        } finally {
            setLoadingCart(false);
        }
    };

    const fetchDeliveryAddress = async () => {
        try {
            if (!customer) return;

            setLoadingAddress(true);

            const params = new URLSearchParams({
                customer_id: customer.id.toString(),
            });

            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/customer/get-delivery-address?${params.toString()}`
            );

            if (!res.ok) throw new Error("Fetch failed");

            const json = await res.json();

            setGetCustomer(json.data);

        } catch (error) {
            console.error(error);
        } finally {
            setLoadingAddress(false);
        }
    };

    const fetchProduct = async () => {
        try {
            setLoadingProduct(true);

            const params = new URLSearchParams({
                // customer_id: customer.id.toString(),
            });

            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/product/get-product?${params.toString()}`
            );

            if (!res.ok) throw new Error("Fetch failed");

            const json = await res.json();
            setProduct(json.data);

        } catch (error) {
            console.error(error);
        } finally {
            setLoadingProduct(false);
        }
    };

    const fetchPaymentMethod = async () => {
        try {
            // setLoadingProduct(true);

            const params = new URLSearchParams({
                // customer_id: customer.id.toString(),
            });

            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/payment`
            );

            if (!res.ok) throw new Error("Fetch failed");

            const json = await res.json();
            setPaymentMethod(json.data);

        } catch (error) {
            console.error("error");
        }
    };

    const fetchTransport = async () => {
        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/customer/get-transport`
            );

            if (!res.ok) throw new Error("Fetch failed");

            const json = await res.json();
            setGetTransport(json.data);

        } catch (error) {
            console.error("error");
        }
    };

    const handleProductDetail = async (id: number) => {
        try {
            setLoadingProductDetail(true);
            setActiveOption(2);

            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/product/product-detail/${id}`
            );

            if (!res.ok) throw new Error("Fetch failed");

            const json = await res.json();

            setProductDetail(json.data);
            setActiveProductId(id);

        } catch (error) {
            console.error(error);
        } finally {
            setLoadingProductDetail(false);
        }
    };

    const handleAddAdress = async (e: React.FormEvent) => {
        e.preventDefault();
        if (loading) return;

        setErrors({});
        setLoading(true);

        if (!customer) {
            return;
        }

        const provinceName =
            provinces.find(p => String(p.Id) === String(provinceId))?.Name || "";

        const districtName =
            districts.find(d => String(d.Id) === String(districtId))?.Name || "";

        const wardName =
            wards.find(w => String(w.Id) === String(wardId))?.Name || "";

        const payload = {
            ...form,
            province: provinceName,
            district: districtName,
            ward: wardName,
            customer_id: customer.id,
            ...(editingAddress && { id: editingAddress.id }),
        };

        const url = editingAddress
            ? `${process.env.REACT_APP_API_URL}/customer/update-address`
            : `${process.env.REACT_APP_API_URL}/customer/add-address`;

        try {
            const res = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (!res.ok) {
                if (data.errors) {
                    setErrors(data.errors);
                }
                return;
            }

            setLoading(false);

            await Swal.fire({
                icon: "success",
                title: "Thành công",
                text: editingAddress
                    ? "Cập nhật địa chỉ thành công!"
                    : "Thêm địa chỉ thành công!",
                timer: 1500,
                showConfirmButton: false,
            });

            fetchDeliveryAddress();
            setOpenRepair(false)
        } catch (error) {
            console.error("Update error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteImages = async (imageIds: number[]) => {
        const result = await Swal.fire({
            title: "Xác nhận xóa",
            text: `Bạn có chắc muốn xóa ${imageIds.length} ảnh không?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Xóa",
            cancelButtonText: "Hủy",
            confirmButtonColor: "#e50014",
            cancelButtonColor: "#6b7280",
            reverseButtons: true,
        });

        if (!result.isConfirmed) return;

        try {
            await fetch(`${process.env.REACT_APP_API_URL}/cart/delete`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    image_ids: imageIds,
                }),
            });

            fetchCart();

            Swal.fire({
                icon: "success",
                title: "Đã xóa",
                text: "Ảnh đã được xóa thành công",
                timer: 1500,
                showConfirmButton: false,
            });

        } catch (error) {
            console.error("Delete images failed", error);

            Swal.fire({
                icon: "error",
                title: "Lỗi",
                text: "Xóa ảnh thất bại, vui lòng thử lại",
            });
        }
    };

    const handleCompleteOrder = async () => {
  
        const result = await Swal.fire({
            title: "Xác nhận đặt hàng",
            text: "Bạn có chắc chắn muốn hoàn tất đơn hàng này không?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy",
            reverseButtons: true,
        });

        if (!result.isConfirmed) return;

        try {
            setLoading(true)

            const payload = {
                customer_id: customer?.id,
                delivery_address_id: selectedAddress?.id,
                transport_id: selectedTransport?.id,
                payment_method_id: selectedPaymentMethod?.id,
                total_amount: totalAmount,
                point_used: pointUsed,
                ship_fee: selectedTransport.ship_fee,
                point: accumulation,
                select_images: selectedImages
            };
            // console.log(payload)
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/order/store`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!res.ok) {
                throw new Error("Gửi dữ liệu thất bại");
            }

            await res.json();
            fetchCart();
            fetchProduct();
            fetchTransport();
            fetchPaymentMethod();
            fetchDeliveryAddress();
            setPageUpload(true);
            setCurrentStep(0);
            setPageOrderConfirm(false)

            setLoading(false)
            Swal.fire({
                icon: "success",
                title: "Hoàn tất đặt hàng",
                text: "Bạn đã đặt hàng thành công!",
            });

        } catch (error) {
            console.error("error");
            Swal.fire({
                icon: "error",
                title: "Lỗi",
                text: "Không thể gửi đơn hàng, vui lòng thử lại",
            });
        } finally {
            setLoading(false)
        }
    };

    const handleChooseFile = () => {
        fileInputRef.current?.click();
    };

    const handleChooseFolder = () => {
        folderInputRef.current?.click();
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const fileList = e.target.files;
        if (!fileList) return;

        const newFiles = Array.from(fileList);
        handleAddFiles(newFiles);

        e.target.value = "";
    };

    const handleRemoveImage = (index: number) => {
        setFiles((prev) => prev.filter((_, i) => i !== index));
    };

    const handleAddFiles = (newFiles: File[]) => {
        setFiles((prev) => [...prev, ...newFiles]);

        const newItems = newFiles.map((file) => {
            const url = URL.createObjectURL(file);

            const img = new Image();
            img.src = url;

            return new Promise<ListImages>((resolve) => {
                img.onload = () => {
                    resolve({
                        id: Date.now() + Math.random(),
                        image_name: file.name,
                        image_url: url,
                        image_size: String(file.size),
                        quantity: 1,
                        position: {
                            x: img.naturalWidth,
                            y: img.naturalHeight,
                            left: 1,
                            top: 1,
                            rotate: 0,
                            scale: 1,
                        },
                    });
                };
            });
        });

        Promise.all(newItems).then((results) => {
            setLocalImages((prev) => [...prev, ...results]);
        });
    };

    const getFileFromEntry = (entry: any): Promise<File> => {
        return new Promise((resolve) => {
            entry.file((file: File) => resolve(file));
        });
    };

    const readDirectory = async (dirEntry: any): Promise<File[]> => {
        const reader = dirEntry.createReader();

        const entries: any[] = await new Promise((resolve) => {
            reader.readEntries(resolve);
        });

        const files: File[] = [];

        for (const entry of entries) {
            if (entry.isFile) {
                const file = await getFileFromEntry(entry);
                files.push(file);
            } else if (entry.isDirectory) {
                const nested = await readDirectory(entry);
                files.push(...nested);
            }
        }

        return files;
    };

    const handleDrop = async (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();

        const items = e.dataTransfer.items;
        if (!items) return;

        const files: File[] = [];

        for (const item of Array.from(items)) {
            const entry = (item as any).webkitGetAsEntry?.();

            if (entry) {
                if (entry.isFile) {
                    const file = await getFileFromEntry(entry);
                    if (file) files.push(file);
                } else if (entry.isDirectory) {
                    const folderFiles = await readDirectory(entry);
                    files.push(...folderFiles);
                }
            } else {
                const file = item.getAsFile();
                if (file) files.push(file);
            }
        }

        handleAddFiles(files);
    };

    const getVisibleSteps = () => {
        const total = steps.length;

        if (currentStep === 0) {
            return steps.slice(0, 3);
        }

        if (currentStep === total - 1) {
            return steps.slice(total - 3, total);
        }

        return steps.slice(currentStep - 1, currentStep + 2);
    };

    const visibleSteps = getVisibleSteps();

    const handleResizeStart = (
        e: React.MouseEvent,
        index: number,
        dir: ResizeDir
    ) => {
        e.preventDefault();
        e.stopPropagation();

        const startX = e.clientX;
        const startY = e.clientY;

        const start = selectedImages[index]?.position;
        if (!start) return;

        const { x: startW, y: startH, left: startL, top: startT } = start;

        const onMouseMove = (ev: MouseEvent) => {
            const dx = ev.clientX - startX;
            const dy = ev.clientY - startY;

            const rad = (-rotation * Math.PI) / 180;
            const localDx = dx * Math.cos(rad) - dy * Math.sin(rad);
            const localDy = dx * Math.sin(rad) + dy * Math.cos(rad);

            let newW = startW;
            let newH = startH;
            let newL = startL;
            let newT = startT;

            /* ===== EAST (right) ===== */
            if (dir.includes("e")) {
                newW = Math.max(MIN_SIZE, startW + localDx);
            }

            if (dir.includes("s")) {
                newH = Math.max(MIN_SIZE, startH + localDy);
            }

            if (dir.includes("w")) {
                const rawW = startW - localDx;
                newW = Math.max(MIN_SIZE, rawW);
                newL = startL + (startW - newW);
            }

            if (dir.includes("n")) {
                const rawH = startH - localDy;
                newH = Math.max(MIN_SIZE, rawH);
                newT = startT + (startH - newH);
            }

            setSelectedImages(prev => {
                const next = [...prev];
                next[index] = {
                    ...next[index],
                    position: {
                        ...next[index].position,
                        x: newW,
                        y: newH,
                        left: newL,
                        top: newT,
                    },
                };
                return next;
            });
        };

        const onMouseUp = () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };

        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
    };

    const handleDragStart = (
        e: React.MouseEvent,
        index: number
    ) => {
        e.preventDefault();
        e.stopPropagation();

        const startX = e.clientX;
        const startY = e.clientY;

        const start = selectedImages[index]?.position;
        if (!start) return;

        const { left: startL, top: startT } = start;

        const onMouseMove = (ev: MouseEvent) => {
            const dx = ev.clientX - startX;
            const dy = ev.clientY - startY;

            const rad = (-rotation * Math.PI) / 180;
            const localDx = dx * Math.cos(rad) - dy * Math.sin(rad);
            const localDy = dx * Math.sin(rad) + dy * Math.cos(rad);

            setSelectedImages(prev => {
                const next = [...prev];
                next[index] = {
                    ...next[index],
                    position: {
                        ...next[index].position,
                        left: startL + localDx,
                        top: startT + localDy,
                    },
                };
                return next;
            });
        };

        const onMouseUp = () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };

        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
    };

    function getCursor(dir: string, rotation: number) {
        const step = ((Math.round(rotation / 90) % 4) + 4) % 4;

        const table: Record<string, string[]> = {
            n: ["n", "w", "s", "e"],
            e: ["e", "n", "w", "s"],
            s: ["s", "e", "n", "w"],
            w: ["w", "s", "e", "n"],

            ne: ["ne", "nw", "sw", "se"],
            nw: ["nw", "sw", "se", "ne"],
            se: ["se", "ne", "nw", "sw"],
            sw: ["sw", "se", "ne", "nw"],
        };

        return `${table[dir][step]}-resize`;
    }

    const getCropData = () => {
        if (selectedIndex === null) return null;

        const img = selectedImages[selectedIndex];
        if (!img?.position) return null;

        const { left, top, x, y, rotate } = img.position;

        return {
            left: left,
            top: top,
            width: x,
            height: y,
            rotation: rotation,
            cropRotation: rotate || 0
        };
    };

    const updateQuantity = (
        index: number,
        type: "plus" | "minus"
    ): void => {
        setSelectedImages(prev => {
            const newImages = [...prev];
            const current = newImages[index];

            const newQuantity =
                type === "plus"
                    ? current.quantity + 1
                    : Math.max(1, current.quantity - 1);

            newImages[index] = {
                ...current,
                quantity: newQuantity,
            };

            handleUpdateQuantity(current.id, newQuantity);

            return newImages;
        });
    };

    const totalPrice = useMemo(() => {
        let total = 0;

        if (selectedColor) total += Number(selectedColor.price);
        if (selectedFrame) total += Number(selectedFrame.price);
        if (selectedSize) total += Number(selectedSize.price);

        return total;
    }, [selectedColor, selectedFrame, selectedSize]);

    const formatVnPhone = (tel?: string) => {
        if (!tel) return "";

        // bỏ ký tự không phải số
        let phone = tel.replace(/\D/g, "");

        // Chuẩn hoá về dạng 84xxxxxxxxx
        if (phone.startsWith("0")) {
            phone = "84" + phone.slice(1);
        }

        if (!phone.startsWith("84") || phone.length !== 11) {
            return tel; // không phải số VN chuẩn
        }

        const national = phone.slice(2);

        return `(+84) ${national.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3")}`;
    };

    const formatNumberVN4 = (value: number | string) => {
        return new Intl.NumberFormat("vi-VN", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 4,
        }).format(Number(value));
    };

    const formatVND = (value: number | string | null | undefined) => {
        const number = Number(value);

        return new Intl.NumberFormat("vi-VN", {
            style: "currency",
            currency: "VND",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(isNaN(number) ? 0 : number);
    };

    const getTomorrowVN = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);

        const day = tomorrow.getDate();
        const month = tomorrow.getMonth() + 1;
        const year = tomorrow.getFullYear();

        return `Ngày ${day} tháng ${month} năm ${year}`;
    };

    const formatDeliveryRangeVN = (expectedDays?: number | string | null) => {
        const days = Number(expectedDays);
        if (!days || days <= 0) return "";

        const startDate = new Date();
        startDate.setDate(startDate.getDate() + days);

        const endDate = new Date();
        endDate.setDate(endDate.getDate() + days + 1);

        const format = (d: Date) =>
            `Ngày ${d.getDate()} tháng ${d.getMonth() + 1} năm ${d.getFullYear()}`;

        return `${format(startDate)} - ${format(endDate)}`;
    };

    const totalAmount = useMemo(() => {
        const productTotal = selectedImages.reduce((sum, item, index) => {
            const price = Number(item.total_amount) || 0;
            const qty = Number(item.quantity) || 0;
            const itemTotal = price * qty;

            return sum + itemTotal;
        }, 0);

        const shipFee = Number(selectedTransport?.ship_fee) || 0;
        const point = Number(pointUsed) || 0;
        const fee = Number(selectedPaymentMethod?.fee) || 0;

        const total = productTotal + shipFee - point + fee;

        return Math.floor(total);
    }, [selectedImages, selectedTransport?.ship_fee, pointUsed, selectedPaymentMethod?.fee,]);

    const accumulation = useMemo(() => {

        if (totalAmount < 1) {
            return
        }

        return Math.floor(totalAmount / 1000);

    }, [totalAmount]);

    useEffect(() => {
        if (selectedIndex === null) return;

        const rotate = selectedImages[selectedIndex]?.position?.rotate ?? 0;
        setRotation(rotate);
    }, [selectedIndex, selectedImages]);

    useEffect(() => {
        setSelectColorId(null);
        setSelectFrameId(null);
        setSelectSizeId(null);

        setSelectedColor(null);
        setSelectedFrame(null);
        setSelectedSize(null);
    }, [activeProductId]);

    useEffect(() => {
        fetchCart();
    }, [customer]);

    useEffect(() => {
        fetchProduct();
        fetchTransport();
        fetchPaymentMethod();

        fetch("/data/vietnam-address.json")
            .then(res => res.json())
            .then(data => setProvinces(data));
    }, []);

    useEffect(() => {
        fetchDeliveryAddress();
    }, [customer]);

    useEffect(() => {
        if (!files.length) return;

        const urls = files.map((file) => URL.createObjectURL(file));
        setImages(urls);

        urls.forEach((url, index) => {
            const img = new Image();
            img.src = url;
        });

        return () => {
            urls.forEach((url) => URL.revokeObjectURL(url));
        };
    }, [files]);

    useEffect(() => {
        setShowLoading(true);
        setImgLoaded(false);
    }, [selectedIndex]);

    useEffect(() => {
        if (!imgLoaded) return;

        const timer = setTimeout(() => {
            setShowLoading(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, [imgLoaded]);

    useEffect(() => {
        if (!editingAddress) return;

        setForm(prev => ({
            ...prev,
            name: editingAddress.customer_name ?? "",
            tel: editingAddress.tel ?? "",
            note_address: editingAddress.note_address ?? "",
            province: editingAddress.province ?? "",
            district: editingAddress.district ?? "",
            ward: editingAddress.ward ?? "",
            is_default: Boolean(editingAddress.is_default),
        }));
    }, [editingAddress]);

    useEffect(() => {
        if (!editingAddress || provinces.length === 0) return;

        const province = provinces.find(
            p => p.Name === editingAddress.province
        );

        if (province) {
            setProvinceId(province.Id);
        }
    }, [editingAddress, provinces]);

    useEffect(() => {
        if (!editingAddress || districts.length === 0) return;

        const district = districts.find(
            d => d.Name === editingAddress.district
        );

        if (district) {
            setDistrictId(district.Id);
        }
    }, [editingAddress, districts]);

    useEffect(() => {
        if (!editingAddress || wards.length === 0) return;

        const ward = wards.find(
            w => w.Name === editingAddress.ward
        );

        if (ward) {
            setWardId(ward.Id);
        }
    }, [editingAddress, wards]);

    useEffect(() => {
        if (!getCustomer?.delivery_address) return;

        const defaultAddress = getCustomer.delivery_address.find(
            a => Boolean(a.is_default)
        );

        if (defaultAddress) {
            setSelectedAddressId(defaultAddress.id);
        }
    }, [getCustomer]);

    useEffect(() => {
        const addresses = getCustomer?.delivery_address;

        if (
            Array.isArray(addresses) &&
            addresses.length > 0 &&
            !selectedAddressId
        ) {
            const defaultAddress =
                addresses.find((a) => a.is_default) ?? addresses[0];

            setSelectedAddressId(defaultAddress.id);
            setSelectedAddress(defaultAddress);
        }
    }, [getCustomer, selectedAddressId]);

    return (
        <>
            <Header />

            <div className=" bg-red-100 py-3">
                <p className="max-w-[144rem] mx-auto text-center text-[#046DB3] font-medium text-[1.6rem] w-[96%]">Miễn phí vận chuyển cho đơn hàng từ 100 sản phẩm trở lên.</p>
            </div>

            <div className="max-w-[144rem] mx-auto flex w-[96%] items-start md:items-center my-8 text-[1.6rem] md:text-[1.4rem] justify-between gap-10 leading-none flex-col md:flex-row">
                <p className="text-[2.4rem] md:text-[2rem] font-medium">In ảnh chuyên nghiệp</p>
                <div className="flex">
                    {visibleSteps.map((stepName, i) => {
                        let realIndex;

                        if (currentStep === 0) {
                            realIndex = i;
                        } else if (currentStep === steps.length - 1) {
                            realIndex = steps.length - 3 + i;
                        } else {
                            realIndex = currentStep - 1 + i;
                        }

                        const isActive = realIndex === currentStep;
                        const isFirst = realIndex === 0;

                        return (
                            <p
                                key={realIndex}
                                className={`text-white pl-3 pr-1 py-3 w-[18rem] md:w-[16rem] h-[4.5rem] flex justify-center items-center text-center 
                                    ${isActive ? "bg-[#046DB3]" : "bg-[#979797]"} 
                                    ${isFirst ? "[clip-path:polygon(0_0,92%_0,100%_50%,92%_100%,0_100%)]" : "[clip-path:polygon(0_0,92%_0,100%_50%,92%_100%,0_100%,8%_50%)]"}
                                `}>
                                {stepName}
                            </p>
                        );
                    })}
                </div>
            </div>

            {pageOrderConfirm && (
                <div className="w-[96%] max-w-[144rem] mx-auto p-4 bg-white flex flex-col gap-8 text-[1.6rem] md:text-[1.4rem]">
                    <p className="text-[2.8rem] md:text-[2.4rem] font-bold pb-2 border-b-2 border-black">
                        Xác nhận đặt hàng
                    </p>

                    <div className="flex gap-8 md:gap-4 flex-col md:flex-row mt-4">
                        <div className="border rounded-md w-full">
                            <div className="bg-gray-100 text-[2rem] px-3 py-2 font-bold">
                                Ngày gửi hàng dự kiến
                            </div>
                            <div className="p-3">{getTomorrowVN()}</div>
                        </div>

                        <div className="border rounded-md w-full">
                            <div className="bg-gray-100 text-[2rem] px-3 py-2 font-bold">
                                Ngày giao hàng dự kiến
                            </div>
                            <div className="p-3">
                                {formatDeliveryRangeVN(selectedTransport?.expected_delivery_date)}
                            </div>
                        </div>
                    </div>

                    <div className="flex gap-8 md:gap-4 flex-col md:flex-row">
                        {/* Delivery */}
                        <div className="border rounded-md w-full">
                            <div className="bg-gray-100 text-[2rem] px-3 py-2 font-bold">
                                Phương thức giao hàng
                            </div>
                            <div className="p-3">{selectedTransport?.transport_name}</div>
                        </div>

                        {/* Payment */}
                        <div className="border rounded-md w-full">
                            <div className="bg-gray-100 px-3 py-2 font-bold text-[2rem]">
                                Phương thức thanh toán
                            </div>
                            <div className="p-3 space-y-1">
                                <p>{selectedPaymentMethod.payment_method_name}</p>
                            </div>
                        </div>
                    </div>

                    {/* Address */}
                    <div className="border rounded-md">
                        <div className="bg-gray-100 text-[2rem] px-3 py-2 font-bold flex gap-5 items-baseline flex-wrap">
                            Thông tin giao hàng
                            {/* <p className="text-red-500 text-[1.4rem]">*Vui lòng kiểm tra chính xác địa chỉ.</p> */}
                        </div>
                        <div className="p-3">
                            <p className="text-2xl font-medium">{selectedAddress?.customer_name}</p>
                            <p>{selectedAddress?.note_address}</p>
                            <p>{[selectedAddress?.ward, selectedAddress?.district, selectedAddress?.province]
                                .filter(Boolean)
                                .join(", ")}
                            </p>
                            <p>Số điện thoại: {selectedAddress?.tel}</p>
                        </div>
                    </div>

                    {/* Order Summary */}
                    <div className="border rounded-md">
                        <div className="bg-gray-100 px-3 py-2 font-bold text-[2rem]">
                            Chi tiết đơn hàng
                        </div>

                        <div className="p-[1rem] flex flex-col gap-4">
                            <div className="flex flex-col gap-2">
                                {selectedImages.map((item) => (
                                    <p key={item.id} className="flex flex-wrap">
                                        <span className="mr-auto">{item.image_name}</span>
                                        <span className="ml-auto">
                                            {formatVND((Number(item.total_amount) || 0) * (Number(item.quantity) || 0))}
                                        </span>
                                    </p>
                                ))}
                                <p className="flex flex-wrap">
                                    <span className="mr-auto">Phí vận chuyển</span>
                                    <span className="ml-auto">
                                        {formatVND(selectedTransport?.ship_fee) || 0}
                                    </span>
                                </p>
                                <p className="flex flex-wrap">
                                    <span className="mr-auto">Phí giao dịch</span>
                                    <span className="ml-auto">{formatVND(selectedPaymentMethod?.fee)}</span>
                                </p>
                                <p className="flex flex-wrap">
                                    <span className="mr-auto">Quy đổi điểm</span>
                                    <span className="ml-auto">
                                        {Number(pointUsed) > 0
                                            ? `-${formatVND(pointUsed)}`
                                            : formatVND(0)}
                                    </span>
                                </p>
                            </div>
                            <p className="flex justify-between border-t-2 border-dashed pt-4 items-end mt-3">
                                <span className="text-[2rem] font-bold">Tổng tiền</span>
                                <span className="text-red-500 text-[3.2rem] md:text-[2.8rem] font-bold">
                                    {formatVND(totalAmount)}
                                </span>
                            </p>

                        </div>
                    </div>

                    {/* Point */}
                    <div>
                        <div className="border rounded-md ">
                            <p className="font-bold text-[2.4rem] md:text-[2rem] py-2 px-3 bg-gray-100">Điểm tích được từ đơn hàng này</p>
                            <div className="flex gap-5 p-3 items-center md:flex-row flex-col">
                                <p className="w-[10rem] text-center underline text-2xl">{accumulation} điểm</p>
                                <p className="flex-1 border-t md:border-t-0 md:border-l pl-5">Đối với các phương thức thanh toán bằng thẻ tín dụng và cửa hàng tiện lợi, điểm thưởng sẽ được cộng vào tài khoản sau 2-3 ngày kể từ khi sản phẩm được giao.<br />
                                    Đối với hình thức thanh toán tiền mặt khi nhận hàng, điểm thưởng sẽ được cộng sau khi thanh toán được xác nhận.<br />
                                    *Điểm sẽ được tính dựa trên giá in (không bao gồm thuế).</p>
                            </div>
                        </div>
                        {/* <p className="mt-3 text-center">Bạn có thể hủy đơn hàng trong vòng 30 phút sau khi hoàn tất đơn hàng.<br />Bạn có thể thực hiện việc này thông qua Trang của tôi.</p> */}
                    </div>

                    <div className="flex justify-center gap-4 font-bold mb-10">
                        <button
                            onClick={() => {
                                setPayment(true);
                                setCurrentStep(3);
                                setPageOrderConfirm(false)
                            }}
                            className="border-black px-16 py-4 rounded-md border-2 shadow-md"
                        >
                            Quay lại
                        </button>
                        <button
                            onClick={handleCompleteOrder}
                            className="bg-[#046DB3] text-white px-16 py-4 rounded-md shadow-md"
                        >
                            Hoàn tất
                        </button>
                    </div>
                </div>
            )}

            {payment && (
                <div className="w-[96%] max-w-[144rem] m-auto mt-[4rem] leading-none">
                    <div className="">
                        <p className="font-bold text-[2.4rem] pb-[1.5rem] border-b-2 border-black leading-none">Chọn phương thức giao hàng và thanh toán</p>
                        <div className="flex mt-12 gap-[2.5rem] flex-col lg:flex-row items-start">
                            <div className="flex-1 flex flex-col gap-6 mb-16 text-[1.6rem] md:text-[1.4rem]">

                                <div className="leading-none">
                                    <p className="font-bold flex items-center gap-3 text-[2.4rem] md:text-[2rem]">Phương thức giao hàng
                                        <button>
                                            <svg className="h-[3rem] w-[3rem] md:h-[2.4rem] md:w-[2.4rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#1f1f1f"><path d="M513.5-254.5Q528-269 528-290t-14.5-35.5Q499-340 478-340t-35.5 14.5Q428-311 428-290t14.5 35.5Q457-240 478-240t35.5-14.5ZM442-394h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>
                                        </button>
                                    </p>
                                    <div className="flex flex-col gap-3">
                                        {getTransport.map((item) => {
                                            const isSelected = selectedTransport?.id === Number(item.id);

                                            return (
                                                <div
                                                    key={item.id}
                                                    onClick={() => {
                                                        setSelectedTransport(item)
                                                    }}
                                                    className={`bg-[#ebebe3] border-[3px] rounded-md flex items-center mt-3 gap-8 px-10 py-5 justify-between cursor-pointer transition-all
                                                                ${isSelected ? 'border-[#11ba79] bg-white' : 'hover:opacity-60'}
                                                            `}
                                                >
                                                    <div className="flex flex-col items-center w-[9.3rem]">
                                                        {isSelected ? (
                                                            <>
                                                                <svg
                                                                    className="w-[4.4rem] h-[4.4rem]"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 -960 960 960"
                                                                    fill="#11ba79"
                                                                >
                                                                    <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
                                                                </svg>
                                                                <p className="text-[#11ba79] text-[1.8rem] font-bold">
                                                                    Đã chọn
                                                                </p>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <svg
                                                                    className="w-[4.4rem] h-[4.4rem]"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 -960 960 960"
                                                                    fill="grey"
                                                                >
                                                                    <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                                                                </svg>
                                                                <p className="text-[grey] text-[1.8rem] font-bold">
                                                                    Chọn
                                                                </p>
                                                            </>
                                                        )}
                                                    </div>

                                                    <div className="flex-1 text-[1.6rem] flex flex-col gap-3">
                                                        <p className="font-bold text-[2rem]">{item.transport_name}</p>
                                                        <p className="leading-[1.2] text-[1.4rem] whitespace-pre-line">{item.note}</p>
                                                    </div>

                                                    <p className="text-[2.2rem] font-bold">
                                                        {formatVND(item.ship_fee)}
                                                    </p>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* <div className="border-t-[2px] pt-6 border-dashed mt-4 flex items-center gap-5">
                                    <p className="font-bold text-[2.4rem] md:text-[2rem]">
                                        Mã giảm giá
                                    </p>
                                    <input
                                        type="text"
                                        placeholder="Nhập mã giảm giá"
                                        className="min-w-[24rem] border px-5 py-3 text-[1.6rem] md:text-[1.4rem] rounded"
                                    />
                                </div> */}

                                <div className="border-t-[2px] pt-6 border-dashed mt-4">
                                    <div className="flex items-end gap-5 mb-4">
                                        <h2 className="font-bold text-[2.4rem] md:text-[2rem]">Sử dụng điểm</h2>
                                        <span className="text-gray-600">
                                            Bạn có: {formatNumberVN4(totalPoint)} điểm
                                        </span>
                                    </div>
                                    <div className="grid grid-cols-2 gap-4">
                                        {/* SỬ DỤNG */}
                                        <button
                                            disabled={totalPoint <= 499}
                                            onClick={() => {
                                                if (totalPoint > 499) {
                                                    setUsePoint(true);
                                                }
                                            }}
                                            className={`border rounded py-4 flex flex-col items-center
                                                    ${usePoint ? "border-[#11ba79] border-2" : ""}
                                                    ${totalPoint <= 100 ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
                                                `}
                                        >
                                            <p>Sử dụng</p>

                                            {usePoint ? (
                                                <>
                                                    <svg
                                                        className="w-[4rem] h-[4rem] mt-4"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 -960 960 960"
                                                        fill="#11ba79"
                                                    >
                                                        <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
                                                    </svg>
                                                    <p className="text-[#11ba79] font-bold mt-1">Đã chọn</p>
                                                </>
                                            ) : (
                                                <svg
                                                    className="w-[4rem] h-[4rem] mt-4"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 -960 960 960"
                                                    fill="grey"
                                                >
                                                    <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                                                </svg>
                                            )}
                                            {totalPoint <= 499 && (
                                                <p className="mt-1 italic text-gray-500 text-xl">*Bạn cần có ít nhất 500 điểm để sử dụng</p>
                                            )}
                                        </button>

                                        {/* KHÔNG SỬ DỤNG */}
                                        <button
                                            onClick={() => {
                                                setUsePoint(false);
                                                setPointUsed(0);
                                            }}
                                            className={`border rounded py-4 flex flex-col items-center
                                                ${!usePoint ? "border-[#11ba79]" : ""}
                                            `}
                                        >
                                            <span>Không sử dụng</span>

                                            {!usePoint && (
                                                <>
                                                    <svg
                                                        className="w-[4rem] h-[4rem] mt-4"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 -960 960 960"
                                                        fill="#11ba79"
                                                    >
                                                        <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
                                                    </svg>
                                                    <p className="text-[#11ba79] font-bold mt-1">Đã chọn</p>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                    {usePoint && (
                                        <>

                                            <div className="flex items-center gap-4 mt-4">
                                                <input
                                                    type="number"
                                                    min={0}
                                                    max={totalPoint}
                                                    value={pointUsed}
                                                    onChange={(e) =>
                                                        setPointUsed(
                                                            Math.min(Number(e.target.value), totalPoint)
                                                        )
                                                    }
                                                    placeholder="Nhập số điểm muốn sử dụng"
                                                    className="w-[21rem] border rounded px-4 py-3"
                                                />
                                                <span>Điểm</span>
                                            </div>
                                            <p className="mt-3 text-gray-500 italic">
                                                *Tỷ lệ quy đổi tiền: 1 điểm tích luỹ = 1 ₫
                                            </p>
                                        </>
                                    )}
                                    <p className="mt-3 text-gray-500 italic">
                                        *Tỷ lệ quy đổi điểm: 1.000 ₫ = 1 điểm tích luỹ
                                    </p>
                                </div>

                                <div className="border-t-[2px] pt-6 border-dashed mt-4">
                                    <p className="font-bold mb-3 text-[2.4rem] md:text-[2rem] flex gap-3">Phương thức thanh toán
                                        <svg className="md:w-[2.4rem] md:h-[2.4rem] w-[3rem] h-[3rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#1f1f1f"><path d="M513.5-254.5Q528-269 528-290t-14.5-35.5Q499-340 478-340t-35.5 14.5Q428-311 428-290t14.5 35.5Q457-240 478-240t35.5-14.5ZM442-394h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>
                                    </p>

                                    <div className="grid grid-cols-[repeat(auto-fit,minmax(13rem,1fr))] gap-2 font-bold leading-7">
                                        {paymentMethod.map((item) => {
                                            const isSelected = selectedPaymentMethod?.id === item.id;

                                            return (
                                                <div
                                                    key={item.id}
                                                    onClick={() => setSelectedPaymentMethod(item)}
                                                    className={`rounded pt-3 pb-5 flex flex-col items-center px-4 cursor-pointer transition min-h-[12rem]
                                                        ${isSelected
                                                            ? "border-2 border-[#11ba79]"
                                                            : "border-2 border-gray-300"
                                                        }`}
                                                >
                                                    <p className="text-center font-bold">
                                                        {item.payment_method_name}
                                                    </p>

                                                    <p>
                                                        Phí giao dịch{" "}
                                                        {item.fee === 0 ? (
                                                            <span className="text-[#11ba79] font-semibold">Miễn phí</span>
                                                        ) : (
                                                            <span>
                                                                {formatVND(item.fee)}
                                                            </span>
                                                        )}
                                                    </p>

                                                    {/* Icon + text chỉ hiện khi được chọn */}
                                                    {isSelected && (
                                                        <>
                                                            <svg
                                                                className="w-[4.4rem] h-[4.4rem] md:w-[4rem] md:h-[4rem] mt-2"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 -960 960 960"
                                                                fill="#11ba79"
                                                            >
                                                                <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
                                                            </svg>

                                                            <p className="text-[#11ba79] font-bold mt-1">
                                                                Đã chọn
                                                            </p>
                                                        </>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* <div className="border-t-[2px] pt-6 border-dashed mt-4">
                                    <div className="flex gap-6 justify-between flex-col md:flex-row">
                                        <p className="font-bold mb-3 text-[2.4rem] md:text-[2rem]">Thông tin thẻ tín dụng</p>
                                        <div className="flex mb-4 font-bold">
                                            <button className="border rounded p-6 hover:opacity-60 transition-all">
                                                Sử dụng thẻ mới
                                            </button>
                                            <button className="bg-[#11ba79] text-white rounded p-6 hover:opacity-60 transition-all">
                                                Sử dụng thẻ đã đăng ký
                                            </button>
                                        </div>
                                    </div>
                                    <div className="flex gap-5 mt-3 flex-col md:flex-row">
                                        <div className="flex-1">
                                            <div className="grid grid-cols-[1fr_2fr] gap-2 items-center">
                                                <p>Số thẻ</p>
                                                <input className="border rounded-md p-4" type="text" placeholder="Nhập số thẻ" />
                                                <p>Tên chủ thẻ</p>
                                                <input className="border rounded-md p-4" type="text" placeholder="Nhập tên chủ thẻ" />
                                                <p>Mã bảo mật</p>
                                                <input className="border rounded-md p-4" type="text" placeholder="Nhập mã bảo mật" />
                                            </div>
                                        </div>
                                        <div className="w-[100%] md:w-[27rem]">
                                            <p>Mã bảo mật là dãy số ở mặt sau thẻ của bạn (Một số loại thẻ in ở mặt trước).</p>
                                            <div className="flex gap-3 mt-5">
                                                <div className="w-fit overflow-hidden rounded-md"><img src="./images/orderpayment/atm-after.png" alt="" /></div>
                                                <div className="w-fit overflow-hidden rounded-md"><img src="./images/orderpayment/atm-before.png" alt="" /></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-3 flex items-center gap-4 flex-wrap">
                                        <span>Ngày hết hạn</span>
                                        <select className="p-3 border rounded-md text-[grey] bg-[#f0f1eb]">
                                            <option value="">01</option>
                                            <option value="">02</option>
                                            <option value="">03</option>
                                            <option value="">04</option>
                                            <option value="">05</option>
                                            <option value="">06</option>
                                            <option value="">07</option>
                                            <option value="">08</option>
                                            <option value="">01</option>
                                            <option value="">10</option>
                                            <option value="">11</option>
                                            <option value="">12</option>
                                        </select>
                                        <span>Tháng</span>
                                        <select className="p-3 border rounded-md text-[grey] bg-[#f0f1eb]">
                                            <option value="">22</option>
                                            <option value="">23</option>
                                            <option value="">24</option>
                                            <option value="">25</option>
                                            <option value="">26</option>
                                        </select>
                                        <span>Năm</span>
                                        <div className="flex items-center gap-1">
                                            <input className="" type="checkbox" />
                                            <span>Lưu thông tin thẻ</span>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="font-bold flex items-end gap-4">
                                        <p className=" text-[2.4rem] md:text-[2rem] mb-2">Danh sách thẻ đã lưu</p>
                                        <p className="text-[1.5rem] md:text-[1.3rem] text-red-500 mb-2">
                                            Bạn có thể lưu trữ tối đa 5 thẻ.
                                        </p>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 mt-3 gap-3 border-b-[1px] pb-12">
                                        <div className="border-2 border-[#11ba79] rounded-md p-4 flex ">
                                            <div className="flex-1">
                                                <p>Số thẻ:<br />
                                                    ************173<br /><br />
                                                    Chủ thẻ: VANTINH NGUYEN<br /><br />
                                                    Ngày hết hạn: 08/2026
                                                </p>
                                            </div>
                                            <div className="text-[#11ba79] font-bold inline-flex flex-col items-center">
                                                <svg className="w-[4.4rem] h-[4.4rem] md:w-[4rem] md:h-[4rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#11ba79"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" /></svg>
                                                <span>Đã chọn</span>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>

                            <div className="lg:max-w-[35rem] w-full border-2 text-[1.6rem] md:text-[1.4rem] font-bold rounded-[6px]">
                                <p className="bg-[#f6f6f6] px-4 py-6 leading-none font-bold rounded-t-md text-[2.4rem] md:text-3xl">Hoá đơn</p>
                                <div className="p-[1rem] flex flex-col gap-4">
                                    <div className="text-[1.8rem] md:text-[1.6rem] font-bold">
                                        {/* <p className="text-[2rem] md:text-[1.8rem]">Chọn phương thức giao hàng và thanh toán</p> */}
                                        {/* <p className="mt-4">Mã giảm giá</p>
                                        <button className="text-blue-500 text-[1.6rem] md:text-[1.4rem]">Không được sử dụng</button> */}
                                        <div className="flex flex-wrap mt-2 gap-1">
                                            <p className="">Phương thức giao hàng:</p>
                                            <p className="text-blue-500 text-[1.6rem] ml-auto">{selectedTransport?.transport_name ?? 'Chưa chọn'}</p>
                                        </div>
                                        <div className="flex flex-wrap mt-4 gap-1">
                                            <p className="">Phương thức thanh toán:</p>
                                            <p className="text-blue-500 text-[1.6rem] ml-auto">{selectedPaymentMethod?.payment_method_name ?? "Chưa chọn"}</p>
                                        </div>
                                    </div>
                                    <div className="flex flex-col gap-3 border-t-[2px] pt-5 mt-3">
                                        {selectedImages.map((item) => (
                                            <p key={item.id} className="flex flex-wrap">
                                                <span className="mr-auto">{item.image_name}</span>
                                                <span className="ml-auto">
                                                    {formatVND((Number(item.total_amount) || 0) * (Number(item.quantity) || 0))}
                                                </span>
                                            </p>
                                        ))}
                                        <p className="flex flex-wrap mt-1">
                                            <span className="mr-auto">Phí vận chuyển</span>
                                            <span className="ml-auto">
                                                {formatVND(selectedTransport?.ship_fee) || 0}
                                            </span>
                                        </p>
                                        <p className="flex flex-wrap">
                                            <span className="mr-auto">Phí giao dịch</span>
                                            <span className="ml-auto">{formatVND(selectedPaymentMethod?.fee)}</span>
                                        </p>
                                        <p className="flex flex-wrap">
                                            <span className="mr-auto">Quy đổi điểm</span>
                                            <span className="ml-auto">
                                                {Number(pointUsed) > 0
                                                    ? `-${formatVND(pointUsed)}`
                                                    : formatVND(0)}
                                            </span>
                                        </p>
                                    </div>
                                    <p className="flex justify-between border-t-2 pt-4 items-end mt-3">
                                        <span className="text-[2rem] md:text-[1.6rem]">Tổng tiền</span>
                                        <span className="text-red-500 text-[3.2rem] md:text-[2.4rem]">
                                            {formatVND(totalAmount)}
                                        </span>
                                    </p>
                                    <button
                                        onClick={() => {
                                            if (!selectedTransport) {
                                                Swal.fire({
                                                    icon: "warning",
                                                    title: "Chưa chọn phương thức vận chuyển",
                                                    text: "Vui lòng chọn phương thức vận chuyển",
                                                    confirmButtonText: "Đã hiểu",
                                                });
                                                return;
                                            }

                                            if (!selectedPaymentMethod) {
                                                Swal.fire({
                                                    icon: "warning",
                                                    title: "Chưa chọn phương thức thanh toán",
                                                    text: "Vui lòng chọn phương thức thanh toán",
                                                    confirmButtonText: "Đã hiểu",
                                                });
                                                return;
                                            }
                                            setPageOrderConfirm(true);
                                            setCurrentStep(4);
                                            setPayment(false)
                                        }}
                                        className="text-white mt-4 text-center bg-[#feac00] rounded-[6px] leading-none p-9 md:p-7 shadow-md hover:opacity-70 text-[2rem] md:text-[1.6rem]"
                                    >
                                        Xác nhận
                                    </button>
                                    <button
                                        onClick={() => {
                                            setAddress(true);
                                            setCurrentStep(2);
                                            setPayment(false);
                                            setSelectedTransport(null);
                                            setSelectedPaymentMethod(null);
                                            setUsePoint(false);
                                            setPointUsed(0);
                                        }}
                                        className="border-[3px] text-center border-black bg-white rounded-[6px] leading-none p-9 md:p-6 shadow-md mt-1 hover:opacity-70 text-[2rem] md:text-[1.6rem]"
                                    >
                                        Quay lại
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {address && (
                <div className="w-full max-w-[144rem] m-auto mt-[4rem] leading-none mb-[10rem]">
                    <div className="px-[3rem]">
                        <p className="font-bold text-[3rem] pb-[1.5rem] border-b-[3px] border-black leading-none">
                            Chọn địa chỉ giao hàng
                        </p>
                        <div className="flex mt-12 gap-[2.5rem] flex-col items-center md:flex-row md:items-start">
                            <div className="w-full">
                                <button
                                    onClick={() => {
                                        setEditingAddress(null);
                                        resetForm();
                                        setOpenRepair(true);
                                    }}
                                    className="flex ml-auto text-[1.8rem] md:text-[1.4rem] font-bold border-2 border-[#3f3939] p-4 leading-none rounded-[6px] hover:opacity-70"
                                >
                                    Thêm địa chỉ giao hàng mới
                                </button>

                                <hr className="mt-8" />

                                {loadingAddress ? (
                                    <LoadingData />
                                ) : getCustomer &&
                                    getCustomer.delivery_address &&
                                    getCustomer.delivery_address.length > 0 ? (
                                    getCustomer.delivery_address.map((address) => (
                                        <div key={address.id} className="py-8 border-b">
                                            <div className="flex items-start justify-between gap-8 flex-wrap">
                                                <div className="mt-2">
                                                    <input
                                                        type="radio"
                                                        name="delivery_address"
                                                        checked={selectedAddressId === address.id}
                                                        className="w-10 h-10 accent-red-500 cursor-pointer"
                                                        onChange={() => {
                                                            setSelectedAddressId(address.id);
                                                            setSelectedAddress(address);
                                                        }}
                                                    />
                                                </div>

                                                <div className="flex flex-col gap-2 flex-1">
                                                    <div className="flex flex-col gap-x-8 gap-y-2 lg:items-center leading-[1.2] lg:mb-2 lg:flex-row">
                                                        <p className="font-bold text-[2.8rem] md:text-[2.4rem] lg:border-r-2 lg:pr-8">
                                                            {address.customer_name}
                                                        </p>
                                                        <p className="text-gray-400 text-[1.8rem] font-medium">
                                                            {formatVnPhone(address.tel)}
                                                        </p>
                                                    </div>

                                                    {address.note_address && (
                                                        <p className="text-[1.8rem] md:text-[1.6rem] leading-none">
                                                            {address.note_address}
                                                        </p>
                                                    )}

                                                    <p className="text-[1.8rem] md:text-[1.6rem] leading-none">
                                                        {[address.ward, address.district, address.province]
                                                            .filter(Boolean)
                                                            .join(", ")}
                                                    </p>

                                                    {address.is_default && (
                                                        <p className="text-[1.4rem] w-max rounded-md mt-2 font-medium leading-none border border-red-500 text-red-500 px-4 py-2">
                                                            Mặc định
                                                        </p>
                                                    )}
                                                </div>

                                                <button
                                                    onClick={() => {
                                                        setEditingAddress(address);
                                                        setOpenRepair(true);
                                                    }}
                                                    className="text-white bg-green-500 px-8 py-4 rounded-xl leading-none font-medium"
                                                >
                                                    Sửa
                                                </button>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>Chưa có địa chỉ giao hàng</p>
                                )}

                            </div>

                            <div className="w-full md:max-w-[31rem] lg:max-w-[38rem] border border-solid mb-10 rounded-lg">
                                <p className="bg-[#f6f6f6] px-4 py-6 leading-none font-bold rounded-t-md text-[2.4rem] md:text-3xl">Hoá đơn tạm tính</p>
                                <div className="py-2 px-4 flex flex-col gap-3 leading-none font-bold text-black">
                                    <div className="flex flex-col gap-3 pt-3">
                                        {selectedImages.map((item) => (
                                            <p key={item.id} className="flex flex-wrap">
                                                <span className="mr-auto">{item.image_name}</span>
                                                <span className="ml-auto">
                                                    {formatVND((Number(item.total_amount) || 0) * (Number(item.quantity) || 0))}
                                                </span>
                                            </p>
                                        ))}
                                        <div className="flex justify-between pt-1">
                                            <span>Phí vận chuyển</span>
                                            <span>0₫</span>
                                        </div>

                                        <div className="flex justify-between">
                                            <span>Phí giao dịch</span>
                                            <span>0₫</span>
                                        </div>
                                    </div>
                                    <p className="flex justify-between border-t-[1px] pt-4 items-end mt-4">
                                        <span className="text-[2rem] md:text-[1.6rem]">Tổng tiền</span>
                                        <span className="text-red-600 text-[3.2rem] md:text-[2.4rem]">
                                            {formatVND(totalAmount ?? 0)}
                                        </span>
                                    </p>
                                    <button
                                        onClick={() => { setCurrentStep(3); setPayment(true); setAddress(false) }}
                                        className="mt-6 text-white bg-[#feac00] text-center rounded-xl leading-none p-7 shadow-md hover:opacity-70 text-[2rem] md:text-[1.6rem]"
                                    >
                                        Xác nhận
                                    </button>
                                    <button
                                        onClick={() => { setCurrentStep(1); setPageOrder(true); setAddress(false) }}
                                        className="border-[3px] border-black bg-white rounded-[6px] leading-none p-6 shadow-md mt-2 hover:opacity-70 text-[2rem] md:text-[1.6rem] text-center"
                                    >
                                        Quay lại
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {openRepair && (
                        <div className="bg-black/30 fixed inset-0 z-[12] flex items-center justify-center">
                            <div className=" bg-white w-[96%] max-w-[70rem] rounded-[1rem] overflow-auto">
                                <p className="bg-[#f5f5f5] text-[2.4rem] md:text-[2rem] p-10 font-bold ">
                                    {editingAddress ? "Chỉnh sửa địa chỉ giao hàng" : "Thêm địa chỉ giao hàng mới"}
                                </p>
                                <form onSubmit={handleAddAdress} className="max-w-[65rem] w-[96%] mt-8 mx-auto flex flex-col gap-8 px-8 sm:px-0">
                                    <div className="flex gap-8">
                                        <div className="flex flex-col gap-2 w-full">
                                            <label className="text-[1.4rem]">Họ và tên<span className="text-red-500 ml-1">*</span></label>
                                            <input
                                                name="name"
                                                value={form.name}
                                                onChange={handleChange}
                                                className={`border rounded-xl px-6 py-4 text-2xl ${errors.name ? "border border-[#F32637]" : ""}`}
                                                placeholder="Nguyễn Văn A"
                                            />
                                            {errors.name && (
                                                <p className="text-[#F32637] text-base">
                                                    {errors.name[0]}
                                                </p>
                                            )}
                                        </div>

                                    </div>

                                    <div className="flex flex-col gap-2">
                                        <label className="text-[1.4rem]">Số điện thoại<span className="text-red-500 ml-1">*</span></label>
                                        <input
                                            type="number"
                                            name="tel"
                                            value={form.tel}
                                            onChange={handleChange}
                                            className={`border rounded-xl px-6 py-4 text-2xl ${errors.tel ? "border border-[#F32637]" : ""}`}
                                        />
                                        {errors.tel && (
                                            <p className="text-[#F32637] text-base">
                                                {errors.tel[0]}
                                            </p>
                                        )}
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        {/* Province */}
                                        <div className="flex flex-col gap-2">
                                            <label className="text-[1.4rem]">
                                                Tỉnh / Thành phố<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <select
                                                name="province_id"
                                                value={provinceId}
                                                onChange={e => {
                                                    setProvinceId(e.target.value);
                                                    setDistrictId("");
                                                    setWardId("");
                                                }}
                                                className={`border rounded-xl px-4 py-4 text-2xl appearance-auto ${errors.province ? "border border-[#F32637]" : ""}`}
                                            >
                                                <option value="">-- Chọn tỉnh / thành --</option>
                                                {provinces.map(p => (
                                                    <option key={p.Id} value={p.Id}>
                                                        {p.Name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.province && (
                                                <p className="text-[#F32637] text-base">
                                                    {errors.province[0]}
                                                </p>
                                            )}
                                        </div>

                                        {/* District */}
                                        <div className="flex flex-col gap-2">
                                            <label className="text-[1.4rem]">
                                                Quận / Huyện<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <select
                                                name="district_id"
                                                value={districtId}
                                                onChange={e => {
                                                    setDistrictId(e.target.value);
                                                    setWardId("");
                                                }}
                                                disabled={!provinceId}
                                                className={`border rounded-xl px-4 py-4 text-2xl appearance-auto disabled:bg-gray-100 ${errors.district ? "border border-[#F32637]" : ""}`}
                                            >
                                                <option value="">-- Chọn quận / huyện --</option>
                                                {districts.map(d => (
                                                    <option key={d.Id} value={d.Id}>
                                                        {d.Name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.district && (
                                                <p className="text-[#F32637] text-base">
                                                    {errors.district[0]}
                                                </p>
                                            )}
                                        </div>

                                        {/* Ward */}
                                        <div className="flex flex-col gap-2">
                                            <label className="text-[1.4rem]">
                                                Phường / Xã<span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <select
                                                name="ward_id"
                                                value={wardId}
                                                onChange={e => setWardId(e.target.value)}
                                                disabled={!districtId}
                                                className={`border rounded-xl px-4 py-4 text-2xl appearance-auto disabled:bg-gray-100 ${errors.ward ? "border border-[#F32637]" : ""}`}
                                            >
                                                <option value="">-- Chọn phường / xã --</option>
                                                {wards.map(w => (
                                                    <option key={w.Id} value={w.Id}>
                                                        {w.Name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.ward && (
                                                <p className="text-[#F32637] text-base">
                                                    {errors.ward[0]}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="flex flex-col gap-2">
                                        <label className="text-[1.4rem]">Ghi chú</label>
                                        <textarea
                                            name="note_address"
                                            value={form.note_address}
                                            onChange={handleChange}
                                            placeholder="Chi tiết địa chỉ: hẻm, ngách, khu, số nhà, ...."
                                            className={`border rounded-xl px-6 py-4 text-2xl ${errors.note_address ? "border border-[#F32637]" : ""}`}
                                        />
                                        {errors.note_address && (
                                            <p className="text-[#F32637] text-base">
                                                {errors.note_address[0]}
                                            </p>
                                        )}
                                    </div>

                                    <label className="text-[1.4rem] flex gap-2 items-center">
                                        <input
                                            type="checkbox"
                                            name="is_default"
                                            checked={form.is_default}
                                            onChange={e =>
                                                setForm(prev => ({
                                                    ...prev,
                                                    is_default: e.target.checked,
                                                }))
                                            }
                                            className="w-7 h-7"
                                        />
                                        Lưu là địa chỉ mặc định
                                    </label>

                                    <div className="flex gap-10 justify-center text-[1.6rem] md:text-[1.4rem] font-bold mb-8 mt-6">
                                        <button
                                            onClick={() => setOpenRepair(false)}
                                            className="rounded-lg bg-white font-bold py-5 px-16 border-2 border-black"
                                        >
                                            Hủy
                                        </button>
                                        <button
                                            className="rounded-lg bg-[#efa72e] text-white font-bold py-5 px-16"
                                        >
                                            Xác nhận
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {pageUpload && (
                <>
                    <div className="w-[96%] max-w-[144rem] mx-auto text-[1.6rem] md:text-[1.4rem]">
                        <div className="w-full mx-auto flex justify-end">
                            <div>
                                {/* <div className="flex leading-none justify-end">
                                    <div className="bg-[#e10012] px-5 py-6 w-[10rem] flex flex-col gap-3 text-white justify-between">
                                        <p className="text-center font-bold text-[1.6rem]">L</p>
                                        <p className="text-right">1 tấm</p>
                                    </div>
                                    <div className="bg-white px-5 py-6 w-[10rem] flex flex-col gap-3 border justify-between">
                                        <p className="text-center font-bold text-[1.6rem]">2L</p>
                                        <p className="text-right">0 tấm</p>
                                    </div>
                                    <div className="flex flex-col items-center gap-3 bg-[#51b195] px-5 py-6">
                                        <p className="border-dashed border-2 border-white w-[2.5rem] h-[2.5rem] relative">
                                            <span className="block absolute -bottom-[2px] -left-[2px] bg-white h-4 w-5"></span>
                                        </p>
                                        <p className="text-white font-bold">Chọn khổ giấy</p>
                                    </div>
                                </div> */}
                                <div className="flex gap-5">
                                    {/* <svg className="h-[3rem] w-[3rem] md:h-[2.4rem] md:w-[2.4rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#1f1f1f"><path d="M513.5-254.5Q528-269 528-290t-14.5-35.5Q499-340 478-340t-35.5 14.5Q428-311 428-290t14.5 35.5Q457-240 478-240t35.5-14.5ZM442-394h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"></path></svg>
                                    <button className="text-[#076bcd] md:text-[1.6rem] text-[1.8rem]">Cắt ảnh</button>
                                    <button className="text-[#076bcd] md:text-[1.6rem] text-[1.8rem]">Chỉnh màu</button>
                                    <button className="text-[#076bcd] md:text-[1.6rem] text-[1.8rem]">In ngày tháng</button> */}
                                    <button className="text-[#076bcd] text-[1.7rem] flex items-center gap-2">
                                        <span className="text-nowrap">Hướng dẫn</span>
                                        <svg className="h-[3rem] w-[3rem] md:h-[2.4rem] md:w-[2.4rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#076bcd"><path d="M513.5-254.5Q528-269 528-290t-14.5-35.5Q499-340 478-340t-35.5 14.5Q428-311 428-290t14.5 35.5Q457-240 478-240t35.5-14.5ZM442-394h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"></path></svg>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className=" grid grid-cols-[repeat(auto-fill,minmax(25rem,1fr))] gap-6 mt-20">
                            {loadingCart ? (
                                <div className="col-span-full">
                                    <LoadingData />
                                </div>
                            ) : selectedImages.length === 0 ? (
                                <p className="col-span-full text-center text-2xl text-gray-500 italic">
                                    Bạn chưa tải ảnh lên
                                </p>
                            ) : (
                                selectedImages.map((img, index) => (
                                    <div key={index} className="bg-[#f5f5f5] pb-8 flex flex-col gap-4 rounded-lg overflow-hidden relative">
                                        {deleteMode && (
                                            <div className="absolute inset-0 z-50 bg-black/40 flex items-center justify-center">
                                                <input
                                                    type="checkbox"
                                                    className="w-8 h-8"
                                                    checked={checkedImages.includes(index)}
                                                    onChange={(e) => {
                                                        setCheckedImages(prev =>
                                                            e.target.checked
                                                                ? [...prev, index]
                                                                : prev.filter(i => i !== index)
                                                        );
                                                    }}
                                                />
                                            </div>
                                        )}
                                        <div
                                            className="relative group"
                                            onClick={() => {
                                                setSelectedIndex(index);
                                                setIsCropOpen(true);
                                            }}
                                        >
                                            <img
                                                className="w-full h-60 object-cover cursor-pointer"
                                                src={img.image_url}
                                                alt={img.image_name}
                                            />

                                            <p className="absolute inset-0
                                                    flex items-center justify-center
                                                    text-white text-2xl font-semibold
                                                    bg-black/50
                                                    opacity-0
                                                    group-hover:opacity-100
                                                    transition-opacity duration-300
                                                    pointer-events-none italic
                                                "
                                            >
                                                Chỉnh ảnh
                                            </p>
                                        </div>

                                        <div className="px-4">
                                            <p className="text-center text-[1.6rem] font-medium">{img.image_name}</p>
                                            <div className="flex justify-between mt-4">
                                                <button
                                                    onClick={() => {
                                                        setSelectedIndex(index);
                                                        setOptionProduct(true);
                                                    }}
                                                    className="text-2xl hover:underline"
                                                >
                                                    - Chọn cách in
                                                </button>
                                                <button
                                                    onClick={() => {
                                                        setSelectedIndex(index);
                                                        setIsCropOpen(true);
                                                    }}
                                                    className="text-2xl hover:underline"
                                                >
                                                    - Chỉnh ảnh
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center gap-3 px-4 justify-between mt-4">
                                            <p className="text-2xl">Số lượng</p>
                                            <div className="flex items-center bg-white w-fit">
                                                <button
                                                    onClick={() => updateQuantity(index, "minus")}
                                                    className="bg-[#046DB3] text-white w-10 h-10 flex items-center justify-center text-[3rem]"
                                                >
                                                    <span className="-mt-2 block leading-none">-</span>
                                                </button>

                                                <p className="w-28 flex justify-center font-medium text-2xl">{img.quantity}</p>

                                                <button
                                                    onClick={() => updateQuantity(index, "plus")}
                                                    className="bg-[#046DB3] text-white w-10 h-10 flex items-center justify-center text-[3rem]"
                                                >
                                                    <span className="-mt-2 block leading-none">+</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )))}
                        </div>
                    </div >

                    <div className="bg-black py-4 text-[1.4rem] mt-[14rem]">
                        <div className="mx-auto max-w-[144rem] flex justify-between gap-5 flex-col lg:flex-row items-center w-[96%]">
                            <div className="flex gap-5 font-bold">
                                <button
                                    onClick={() => setUpload(true)}
                                    className="bg-white py-2 px-5 min-w-[15rem] rounded-md text-center"
                                >
                                    <span className="text-[1.8rem]">+</span> Thêm ảnh
                                </button>
                                <button
                                    disabled={selectedImages.length === 0 }
                                    className={`bg-[#e50014] text-white py-2 px-5 min-w-[15rem] rounded-md text-center ${selectedImages.length === 0 ? 'opacity-70' : ''}`}
                                    onClick={async () => {
                                        if (!deleteMode) {
                                            setDeleteMode(true);
                                            return;
                                        }

                                        // đang deleteMode
                                        if (checkedImages.length === 0) {
                                            // không chọn gì → thoát chế độ xóa
                                            setDeleteMode(false);
                                            return;
                                        }

                                        // Lấy danh sách ID cần xóa
                                        const imageIds = checkedImages.map(
                                            index => selectedImages[index].id
                                        );

                                        // Gọi API
                                        await handleDeleteImages(imageIds);

                                        // Update UI
                                        // setSelectedImages(prev =>
                                        //     prev.filter(img => !imageIds.includes(img.id))
                                        // );

                                        setCheckedImages([]);
                                        setDeleteMode(false);
                                    }}
                                >
                                    {deleteMode ? "Xác nhận xóa" : "Xóa"}
                                </button>
                            </div>
                            <div className="flex gap-5 items-center justify-between w-full lg:w-fit">
                                <p className="text-white">
                                    Tổng cộng: {totalQuantity} bản in / Tổng tiền: {formatVND(totalAmount)}</p>
                                <button disabled={!selectedImages.length} onClick={() => setOrderConfirm(true)} className={`text-white flex items-center gap-3 font-bold relative before:content-[''] before:[clip-path:polygon(0_0,85%_0,100%_50%,85%_100%,0_100%)] before:absolute before:inset-0 before:bg-[#e50014] before:-z-10 z-0 pl-8 pr-16  py-3 rounded-t-md rounded-b-md overflow-hidden ${selectedImages.length === 0 ? "opacity-70" : "opacity-100"}`}>
                                    <svg className="w-8 h-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="white"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm40-80h480L570-480 450-320l-90-120-120 160Zm-40 80v-560 560Zm182.5-377.5Q400-595 400-620t-17.5-42.5Q365-680 340-680t-42.5 17.5Q280-645 280-620t17.5 42.5Q315-560 340-560t42.5-17.5Z" /></svg>
                                    <span>Đặt hàng</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {pageOrder && (
                <>
                    <div className="w-[96%] max-w-[144rem] mx-auto md:text-[1.4rem] text-[1.6rem]">
                        <div className=" pt-5">
                            <div className="font-bold text-[3rem] pb-[1.5rem] border-b-[3px] border-black leading-none">
                                <p className="text-[3rem] text-black font-bold ">Tùy chọn sản phẩm</p>
                            </div>


                            {/* container */}
                            <div className="flex-col gap-[2rem] justify-between items-start flex lg:flex-row w-full mt-12">

                                {/* left */}
                                <div className="flex flex-col flex-1 w-full min-w-0">
                                    <p className="text-[2rem] text-black font-bold leading-none">
                                        Thông tin sản phẩm
                                    </p>
                                    {loadingCart ? (
                                        <div className="col-span-full">
                                            <LoadingData />
                                        </div>
                                    ) : (
                                        selectedImages.map((item, index) => (
                                            <div key={index} className="flex mt-5 md:items-start gap-5 justify-between flex-col md:flex-row items-center border-t pt-5">
                                                <div className="flex flex-col">
                                                    <div className="w-full max-w-[40rem] md:md:max-w-[20rem] aspect-[3/2]  bg-[#f5f5f5] rounded-md overflow-hidden">
                                                        <img
                                                            className="w-full object-cover h-full"
                                                            src={item.image_url}
                                                            alt=""
                                                        />
                                                    </div>
                                                    {/* <p className="text-center font-medium text-black-500 mt-2 text-[1.2rem]">
                                                Hình ảnh đã tải lên
                                              </p> */}
                                                </div>
                                                <div className="flex flex-1 justify-between items-start gap-5 w-full">
                                                    <div className="flex flex-col gap-2" >
                                                        <p className="md:text-[1.6rem] text-[1.8rem] text-black font-bold leading-none">
                                                            {item.image_name}
                                                        </p>
                                                        <div className="flex gap-4 mt-2 flex-wrap">
                                                            <div className="flex">
                                                                <p className=" text-black font-bold leading-none">Màu sắc:</p>
                                                                <span className="ml-3 text-[1.4rem] text-black leading-none inline">
                                                                    {item.color?.color_name};
                                                                </span>
                                                            </div>
                                                            <div className="flex">
                                                                <p className=" text-black font-bold leading-none">Khung:</p>
                                                                <span className="ml-3 text-[1.4rem] text-black leading-none inline">
                                                                    {item.frame?.frame_name};
                                                                </span>
                                                            </div>
                                                            <div className="flex">
                                                                <p className=" text-black font-bold leading-none">Kích thước:</p>
                                                                <span className="ml-3 text-[1.4rem] text-black leading-none inline">
                                                                    {item.print_paper_size?.print_paper_size}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="flex flex-col gap-2 mt-1">
                                                            <div className="flex">
                                                                <p className=" text-black font-bold leading-none">Giá tiền: </p>
                                                                <span className="text-[1.4rem] text-black leading-none inline ml-3">
                                                                    {formatVND(item.total_amount)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="flex mt-1">
                                                            <p className=" text-black font-bold leading-none">Số lượng:</p>
                                                            <span className="ml-3 text-[1.4rem] text-black leading-none inline">{item.quantity}</span>
                                                        </div>
                                                        <div className="flex mt-1">
                                                            <p className=" text-black font-bold leading-none">Thành tiền:</p>
                                                            <span className="ml-3 text-[1.4rem] text-black leading-none inline">
                                                                {formatVND((Number(item.total_amount) || 0) * (Number(item.quantity) || 0))}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {selectedImages.length > 1 && (
                                                        <button
                                                            onClick={() => handleDeleteImages([item.id])}
                                                            className="w-fit bg-red-500 px-8 py-4 rounded-md text-white leading-none font-medium"
                                                        >
                                                            Xóa
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        )))}



                                    <div className="mt-16 border-t pt-4">
                                        <p className="text-[2rem] text-black font-bold leading-none">
                                            Mua album
                                        </p>
                                        <p className=" text-black  leading-none pt-4">
                                            Bạn cũng có thể mua thêm album ảnh cùng với những bức ảnh bạn đặt mua.
                                        </p>
                                    </div>

                                    <div className="relative flex items-center mt-[1.8rem] w-full">
                                        <div onClick={() => swiperRef.current?.slidePrev()} className="rounded absolute left-1 top-1/2 w-12 h-12 bg-white/70 flex items-center justify-center -translate-y-1/2 cursor-pointer z-50">
                                            <img src="/images/OrderOption/pre.png" className="w-6 h-6" alt="Prev" />
                                        </div>


                                        <Swiper className="w-full"
                                            modules={[Autoplay]}
                                            autoplay={{ delay: 2000 }}
                                            spaceBetween={24}
                                            // slidesPerView={3}
                                            loop
                                            onSwiper={(swiper: SwiperType) => (swiperRef.current = swiper)}
                                            breakpoints={{
                                                320: {
                                                    slidesPerView: 1.5,
                                                    spaceBetween: 12,
                                                    centeredSlides: true
                                                },
                                                425: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 16,
                                                    centeredSlides: false
                                                },
                                                768: {
                                                    slidesPerView: 3,
                                                    spaceBetween: 20,
                                                }
                                            }}
                                        >
                                            {items.map((item) => (
                                                <SwiperSlide key={item.id}>
                                                    <div className="p-4 border cursor-pointer rounded-xl h-full">
                                                        <div className="relative">
                                                            <img
                                                                src={item.img}
                                                                className="w-full rounded-2xl"
                                                                alt=""
                                                            />

                                                            <p className="py-2 px-3 rounded-md text-white rounded-tr-md bg-[#6ea6e3] absolute top-0 right-0 text-center">
                                                                Kho: {item.store}
                                                            </p>
                                                        </div>

                                                        <div className="pt-4 text-black flex flex-col gap-3 font-bold leading-none">
                                                            <p className="text-[1.8rem]">
                                                                {item.price.toLocaleString()}đ
                                                            </p>
                                                            <p className="text-[1.2rem] font-normal leading-5">
                                                                {item.name}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>

                                        <div onClick={() => swiperRef.current?.slideNext()} className="rounded absolute right-1 top-1/2 w-12 h-12 bg-white/70 flex items-center justify-center -translate-y-1/2 cursor-pointer z-50">
                                            <img src="/images/OrderOption/next.png" className="w-6 h-6" alt="Next" />
                                        </div>
                                    </div>

                                    <button onClick={() => setBuyAlbum(true)} className="bg-[#e8e8e8] p-5 mt-8 flex gap-8 items-center justify-center mb-[4rem]">
                                        <div className="bg-[#56b87f] rounded-full md:max-w-[8rem] h-[8rem] w-[8rem] flex items-center justify-center">
                                            <p className="text-[2rem] text-white font-bold  leading-9">
                                                Gửi<br />đơn
                                            </p>
                                        </div>
                                        <div className="flex flex-col text-[2rem] leading-none font-semibold text-black gap-3">
                                            <p className="text-[#56b87f] ">
                                                Bạn muốn lưu trữ ảnh in ?
                                            </p>
                                            <p>
                                                Album độc quyền của Pri
                                            </p>
                                        </div>
                                    </button>
                                </div>

                                {/* right */}
                                <div className="w-full lg:w-[38rem] border border-solid mb-10 rounded-lg">
                                    <p className="bg-[#f6f6f6] px-4 py-6 leading-none font-bold rounded-t-md text-[2.4rem] md:text-3xl">Hoá đơn tạm tính</p>
                                    <div className="py-2 px-4 flex flex-col gap-3 leading-none font-bold text-black">
                                        <div className="flex flex-col gap-3 pt-3">
                                            {selectedImages.map((item) => (
                                                <p key={item.id} className="flex flex-wrap">
                                                    <span className="mr-auto">{item.image_name}</span>
                                                    <span className="ml-auto">
                                                        {formatVND((Number(item.total_amount) || 0) * (Number(item.quantity) || 0))}
                                                    </span>
                                                </p>
                                            ))}
                                            <div className="flex justify-between pt-1">
                                                <span>Phí vận chuyển</span>
                                                <span>0₫</span>
                                            </div>

                                            <div className="flex justify-between">
                                                <span>Phí giao dịch</span>
                                                <span>0₫</span>
                                            </div>
                                        </div>
                                        <p className="flex justify-between border-t-[1px] pt-4 items-end mt-4">
                                            <span className="text-[2rem] md:text-[1.6rem]">Tổng tiền</span>
                                            <span className="text-red-600 text-[3.2rem] md:text-[2.4rem]">
                                                {formatVND(totalAmount)}
                                            </span>
                                        </p>
                                        <button
                                            onClick={() => {
                                                setAddress(true);
                                                setPageOrder(false);
                                                setCurrentStep(2)
                                            }}
                                            className="mt-6 text-white bg-[#feac00] text-center rounded-xl leading-none p-7 shadow-md hover:opacity-70 text-[2rem] md:text-[1.6rem]"
                                        >
                                            Xác nhận
                                        </button>
                                        <button
                                            onClick={() => {
                                                setCurrentStep(0);
                                                setPageUpload(true);
                                                setPageOrder(false);
                                                fetchCart()
                                            }}
                                            className="border-[3px] mb-4 mt-2 border-black bg-white rounded-[6px] leading-none p-6 shadow-md hover:opacity-70 text-[2rem] md:text-[1.6rem] text-center"
                                        >
                                            Quay lại
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {buyAlbum && (
                <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-[51] md:text-[1.4rem] text-[1.6rem]">
                    <div className="flex flex-col gap-10 py-5 rounded-2xl bg-white w-[95vw] max-w-[85rem]">
                        <button onClick={() => setBuyAlbum(false)} className="text-[2rem] relative w-10 h-10 self-end mr-6">
                            <span className="inline-block bg-[grey] w-full h-1 rotate-45 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></span>
                            <span className="inline-block bg-[grey] w-full h-1 -rotate-45 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></span>
                        </button>
                        <div className="flex flex-col gap-10 max-h-[80vh] overflow-y-auto px-10 items-center">
                            <div className="flex gap-10 items-start w-full flex-col md:flex-row">
                                <div className="flex flex-col gap-5 flex-1 overflow-hidden w-full">
                                    <div className="relative">
                                        <button className="rounded-md absolute -translate-y-1/2 top-1/2 z-10 bg-white/60 p-2 pr-1" onClick={() => swiperRef1.current?.slidePrev()}>
                                            <svg className="w-8 h-8 lg:w-10 lg:h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#1f1f1f"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" /></svg>
                                        </button>
                                        <button className="rounded-md absolute -translate-y-1/2 top-1/2 z-10 bg-white/60 p-2 pl-1 right-0" onClick={() => swiperRef1.current?.slideNext()}>
                                            <svg className="rotate-180 w-8 h-8 lg:w-10 lg:h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#1f1f1f"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" /></svg>
                                        </button>
                                        <Swiper
                                            modules={[Autoplay]}
                                            navigation
                                            pagination={{ clickable: true }}
                                            autoplay={{ delay: 2000 }}
                                            spaceBetween={20}
                                            slidesPerView={1}
                                            onSwiper={(swiper: SwiperType) => (swiperRef1.current = swiper)}
                                            loop={true}
                                        >
                                            {slides1.map((item) => (
                                                <SwiperSlide key={item.id} >
                                                    <div className="relative"><img
                                                        src={item.img}
                                                        className="w-full object-cover rounded-xl"
                                                        alt=""
                                                    />
                                                        <p className="absolute top-0 right-0 bg-[#6ea6e3] text-[1.4rem] text-white px-6 py-5 rounded-md font-bold">Kho: {item.store}</p>
                                                    </div>
                                                    <p className="mt-2">{item.name}</p>
                                                    <p className="font-medium">{item.price.toLocaleString()}đ</p>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </div>
                                    <p className="text-justify">Album ảnh bằng vải lanh bán chạy số 1 của Shimauwa Album nay đã có thêm nhiều màu sắc mới! Album này được làm từ chất liệu vải lanh ấm áp, có thể chứa 300 ảnh cỡ L. *Màu sắc mới không được áp dụng giảm giá khi mua số lượng lớn. Mong quý khách thông cảm. *Quý khách có thể đặt hàng sản phẩm này cùng lúc qua ứng dụng ảnh. *Chỉ hiển thị tùy chọn đặt hàng đồng thời các sản phẩm đủ điều kiện khi đặt ảnh cỡ L. *Không áp dụng cho ảnh cỡ vuông. *Không áp dụng cho đơn đặt hàng ảnh in kỹ thuật số mới.</p>
                                    <div className="rounded bg-[#eeeeee] py-3 px-6 leading-7 text-justify">
                                        <p className="text-[#046DB3] font-medium">Album sẽ được giao bằng dịch vụ chuyển phát nhanh. Phí vận chuyển cố định: 10.000đ.
                                        </p>
                                        <p className="mt-3">Đối với đơn hàng từ 100 ảnh trở lên, phí vận chuyển là 5.000đ (giảm 5.000đ). Vui lòng chờ thêm một ngày để chuẩn bị trước khi giao hàng.</p>
                                    </div>
                                </div>
                                <div className=" flex-1 flex flex-col gap-5 border-b pb-5 w-full">
                                    {products.length > 0 && products.map((item) => (
                                        <div
                                            key={item.id}
                                            className="flex items-center justify-between pt-5 border-t"
                                        >
                                            {/* LEFT */}
                                            <div className="flex items-center gap-3">
                                                <img
                                                    src={item.image}
                                                    alt={item.name}
                                                    className="w-16 h-16 object-cover rounded"
                                                />
                                                <div>
                                                    <p className="">{item.name}</p>
                                                    <p className="font-medium">
                                                        {item.price.toLocaleString()}đ
                                                    </p>
                                                </div>
                                            </div>

                                            {/* RIGHT - COUNTER */}
                                            <div className="flex items-center border rounded-md overflow-hidden p-2">
                                                <button
                                                    className=" w-10 h-10 flex items-center justify-center  hover:bg-gray-100"
                                                >
                                                    −
                                                </button>

                                                <div className="w-10 text-center">
                                                    {quantities[item.id] || 0}
                                                </div>

                                                <button
                                                    className="w-10 h-10 flex items-center justify-center  hover:bg-gray-100"
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <button className="text-[1.8rem] text-white text-center bg-red-800 rounded-full font-medium p-4 min-w-[48rem]">
                                Thêm vào giỏ hàng
                            </button>
                            <div className="max-w-[50rem] w-full px-5 mb-10">
                                <p className="text-[1.8rem] font-medium">Các sản phẩm đề xuất</p>
                                <div className="relative">
                                    <button className="left-0 md:-left-20 rounded-md absolute -translate-y-1/2 top-1/2 z-10 bg-black/60 py-2 pr-0 pl-4" onClick={() => swiperRef2.current?.slidePrev()}>
                                        <svg className="w-8 h-8 lg:w-10 lg:h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="white"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" /></svg>
                                    </button>
                                    <button className="absolute -translate-y-1/2 top-1/2 z-10 bg-black/60 py-2 pl-0 pr-4 md:-right-20 right-0 rounded-md" onClick={() => swiperRef2.current?.slideNext()}>
                                        <svg className="rotate-180 w-8 h-8 lg:w-10 lg:h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="white"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" /></svg>
                                    </button>
                                    <Swiper
                                        modules={[Autoplay]}
                                        navigation
                                        pagination={{ clickable: true }}
                                        autoplay={{ delay: 2000 }}
                                        spaceBetween={20}
                                        // slidesPerView={2}
                                        onSwiper={(swiper: SwiperType) => (swiperRef2.current = swiper)}
                                        loop={true}
                                        className="mt-3"
                                        breakpoints={{
                                            320: {
                                                slidesPerView: 1,
                                                centeredSlides: false
                                            },
                                            425: {
                                                slidesPerView: 1.5,
                                                centeredSlides: true
                                            },
                                            768: {
                                                slidesPerView: 2,
                                                centeredSlides: false
                                            }
                                        }}
                                    >

                                        {slides2.map((item) => (
                                            <SwiperSlide key={item.id} className="relative">
                                                <div><img
                                                    src={item.img}
                                                    className="w-full object-cover rounded-xl"
                                                    alt=""
                                                />
                                                    <p className="absolute top-0 right-0 bg-[#6ea6e3] text-[1.2rem] text-white px-4 py-3 rounded-md font-bold">Kho: {item.store}</p>
                                                </div>
                                                <p>{item.name}</p>
                                                <p className="font-medium">{item.price.toLocaleString()}đ</p>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {upload && (
                <>
                    <input
                        type="file"
                        multiple
                        accept="image/*"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        className="hidden"
                    />
                    <input
                        type="file"
                        multiple
                        accept="image/*"
                        ref={folderInputRef}
                        onChange={handleFileChange}
                        className="hidden"
                        {...({ webkitdirectory: "true", directory: "" } as any)}
                    />

                    <main>
                        <div className=" fixed inset-0 bg-black/30 flex justify-center items-start min-[376px]:items-center z-50 overflow-y-auto p-4">
                            <div className="bg-white w-[95%] max-w-[120rem] rounded-2xl shadow-lg relative">

                                <nav className="bg-gray-100 flex-wrap pt-[6rem] pb-[6rem] rounded-2xl px-[2rem] flex items-center justify-center gap-[1.5rem] relative lg:px-[2rem] md:px-[2rem] md:pt-16 md:pb-[0]" >
                                    <div
                                        className="absolute top-4 right-8 cursor-pointer" onClick={() => setUpload(false)}>
                                        <div className="relative w-10 h-10">
                                            <span className="absolute top-1/2 left-0 w-full h-[2px] bg-[#787772] rotate-45"></span>
                                            <span className="absolute top-1/2 left-0 w-full h-[2px] bg-[#787772] -rotate-45"></span>
                                        </div>
                                    </div>

                                    <button
                                        onClick={() => setActiveTab(1)}
                                        className={`w-[70rem] h-[6.4rem] flex justify-center items-center gap-1 p-8 rounded-t-[.5rem] md:w-[30rem] cursor-pointer 
                                            ${activeTab === 1 ? "bg-white" : "bg-[#e7e7e7] hover:bg-white "}`}>
                                        <img
                                            className="w-[4rem] md:w-[6rem]"
                                            src="/images/list-reservation/icon-01.png"
                                            alt=""
                                        />
                                        <p className="text-[1.8rem] font-bold text-center md:text-[2rem]">
                                            Tải ảnh lên
                                        </p>
                                    </button>

                                    <button onClick={() => setActiveTab(2)} className={`w-[70rem] h-[6.4rem] flex justify-center items-center gap-1 p-8 rounded-t-[.5rem] md:w-[30rem] cursor-pointer 
                                            ${activeTab === 2 ? "bg-white" : "bg-[#e7e7e7] hover:bg-white "}`}>
                                        <img className="w-[4rem] md:w-[6rem]" src={`${process.env.PUBLIC_URL}/images/list-reservation/icon-02.png`} />
                                        <p className="text-[1.8rem] text-center font-bold  md:text-[2rem]">Sử dụng ảnh Facebook</p>
                                    </button>

                                    <button onClick={() => setActiveTab(3)} className={`w-[70rem] h-[6.4rem] flex justify-center items-center gap-1 p-8 rounded-t-[.5rem] md:w-[30rem] cursor-pointer 
                                            ${activeTab === 3 ? "bg-white" : "bg-[#e7e7e7] hover:bg-white "}`}>
                                        <img className="w-[4rem] md:w-[6rem]" src={`${process.env.PUBLIC_URL}/images/list-reservation/icon-03.png`} />
                                        <p className="text-[1.8rem] text-center font-bold md:text-[2rem]">Sử dụng Google Photos</p>
                                    </button>
                                </nav>
                                <div className="max-h-[60vh] md:max-h-[70vh] overflow-y-auto">
                                    {activeTab === 1 && (
                                        <div className="flex justify-center py-12  px-[2rem] md:px-[2rem]">
                                            <div onDragOver={(e) => e.preventDefault()}
                                                onDrop={handleDrop}
                                                className="w-[100%] border-4 border-dashed border-[#dee6d9] rounded-[2rem] p-[1.2rem] text-center md:w-[70rem]"
                                            >
                                                <div className="mt-[3.6rem] cursor-pointer">
                                                    <img
                                                        className="w-[10rem] mx-auto"
                                                        src={`${process.env.PUBLIC_URL}/images/list-reservation/icon-04.png`}
                                                    />
                                                </div>

                                                <div className="mt-[3rem]">
                                                    <p className="text-[2.5rem] text-center font-bold">
                                                        Kéo và thả ảnh của bạn vào đây.
                                                    </p>
                                                </div>

                                                <div className="mt-[1rem]">
                                                    <p className="text-[2.2rem] text-center">hoặc</p>
                                                </div>

                                                <div className=" flex items-center justify-center gap-6 mt-[2.6rem] flex-col md:flex-row ">
                                                    <button
                                                        onClick={handleChooseFile}
                                                        className="flex justify-center items-center rounded-full border border-[#60ad5d] max-w-[50rem] w-[95%] px-[2.9rem] py-[1.2rem] gap-[1rem] md:w-[24rem] md:gap-[.3]"
                                                    >
                                                        <img
                                                            className="w-[4rem] md:w-[2.5rem]"
                                                            src={`${process.env.PUBLIC_URL}/images/list-reservation/icon-05.png`}
                                                        />
                                                        <p className="text-[2rem] text-[#60ad5d] font-bold md:text-[1.6rem]">
                                                            Chọn file
                                                        </p>
                                                    </button>

                                                    <button
                                                        onClick={handleChooseFolder}
                                                        className="flex justify-center items-center rounded-full border border-[#60ad5d] max-w-[50rem] w-[95%] px-[2.9rem] py-[1.2rem] gap-[1rem] md:w-[24rem] md:gap-[.3]"
                                                    >
                                                        <img
                                                            className="w-[4rem] md:w-[2.5rem]"
                                                            src={`${process.env.PUBLIC_URL}/images/list-reservation/icon-06.png`}
                                                        />
                                                        <p className="text-[2rem] text-[#60ad5d] font-bold md:text-[1.6rem]">
                                                            Chọn thư mục
                                                        </p>
                                                    </button>
                                                </div>
                                                {images.length > 0 && (
                                                    <div className="mt-10 flex flex-wrap gap-4 justify-center h-[20rem] overflow-y-auto">
                                                        {images.map((file, index) => (
                                                            <div key={index} className="relative w-[12rem] h-[12rem]">
                                                                <img
                                                                    src={file}
                                                                    className="w-full h-full object-cover rounded-lg"
                                                                />
                                                                <button
                                                                    onClick={() => handleRemoveImage(index)}
                                                                    className="absolute top-1 right-1 text-black rounded-full w-6 h-6 flex items-center justify-center text-[2.6rem]"
                                                                >
                                                                    ×
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                <div className="pt-[1.5rem] w-[95%] mx-auto pb-[1.3rem] md:w-[100%]">
                                                    <p className="text-[1.3rem] text-center text-[#7b7b7b]">
                                                        *Nếu bạn không thể tải lên thư mục, vui lòng tải lên file.
                                                    </p>
                                                </div>
                                                <button onClick={async () => {
                                                    await handleUpload();
                                                    // setSelectedImages(prev => [...prev, ...images]);

                                                }} disabled={images.length === 0} className={`bg-[#eeeeee] p-[1.5rem] rounded-[1rem] w-[95%] mx-auto ${images.length === 0 ? "opacity-50" : "opacity-100"}`}>
                                                    <p className={` justify-center items-baseline gap-3 text-[2rem] leading-snug  font-bold md:text-[1.5rem] ${images.length === 0 ? "hidden" : "flex"}`}><span className="text-[3rem] leading-none inline text-[#e71b62] md:text-[3.5rem]">{images.length}</span>mục được tải lên. Tiếp tục</p>
                                                    <p className={`justify-center items-baseline gap-3 text-[2rem] leading-snug  font-bold md:text-[1.5rem] ${images.length === 0 ? "flex" : "hidden"}`}>Vui lòng tải lên file</p>
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    {activeTab === 2 && (<div className="flex w-full h-[300px] text-[2rem] justify-center items-center p-6">coming soon fb</div>)}
                                    {activeTab === 3 && (<div className="flex w-full h-[300px] text-[2rem] justify-center items-center p-6">coming soon gg</div>)}
                                </div>



                            </div>
                        </div>
                    </main>
                </>
            )}

            {orderConfirm && (
                <div className="flex fixed inset-0 justify-center items-center bg-black/60 text-[1.4rem] font-medium">
                    <div className="bg-white rounded-lg px-6 py-8 w-[96%] max-w-[65rem]">
                        <p className="text-center text-3xl font-bold">Xác nhận đơn hàng</p>
                        <div className="flex flex-col gap-3 mt-12">
                            <table className="w-full border-collapse">
                                <thead>
                                    <tr className="border-b">
                                        <th className="pb-4 px-2 text-left text-2xl">Tên file</th>
                                        <th className="pb-4 px-2 text-left text-2xl">Màu sắc</th>
                                        <th className="pb-4 px-2 text-left text-2xl">Loại khung</th>
                                        <th className="pb-4 px-2 text-left text-2xl">Kích thước</th>
                                        <th className="pb-4 px-2 text-left text-2xl">Số lượng</th>
                                        <th className="pb-4 px-2 text-left text-2xl">Giá tiền</th>
                                        <th className="pb-4 px-2 text-left text-2xl">Thành tiền</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {selectedImages.map((item) => (
                                        <tr key={item.id} className="border-b">
                                            <td className="py-4 px-2">{item.image_name}</td>
                                            <td className="py-4 px-2">{item.color?.color_name ?? '-'}</td>
                                            <td className="py-4 px-2">{item.frame?.frame_name ?? '-'}</td>
                                            <td className="py-4 px-2">{item.print_paper_size?.print_paper_size ?? '-'}</td>
                                            <td className="py-4 px-2 text-right">x{item.quantity}</td>
                                            <td className="py-4 px-2 text-right">
                                                {formatVND(item.total_amount ?? 0)}
                                            </td>

                                            <td className="py-4 px-2 text-right">
                                                {formatVND((Number(item.total_amount) || 0) * (Number(item.quantity) || 0))}
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td className="py-4 px-2 bg-[#eee]" colSpan={6}>Tổng tiền</td>
                                        <td className="py-4 px-2 text-right bg-[#eee]">
                                            {formatVND(totalAmount)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="flex gap-5 justify-center mt-16">
                            <button
                                onClick={() => setOrderConfirm(false)}
                                className="bg-white rounded-md border p-3  min-w-[15rem] hover:opacity-60 transition-all text-center">Quay lại
                            </button>
                            <button
                                onClick={() => { setPageOrder(true); setPageUpload(false); setOrderConfirm(false); setCurrentStep(1) }}
                                className="bg-[#046DB3] text-center text-white rounded-md p-3 min-w-[15rem] hover:opacity-60 transition-all">
                                Xác nhận
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isCropOpen && selectedIndex !== null && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                    {showLoading && (
                        <FormLoading loading />
                    )}
                    <div className="bg-black p-6 rounded-lg max-w-[90vw] md:min-w-[60rem] inline-block">
                        <div className="flex justify-center items-center overflow-hidden duration-200" ref={wrapperRef}>
                            <div
                                className="relative origin-center transition-transform duration-200"
                                style={{
                                    transform: `scale(${finalScale}) rotate(${rotation}deg)`
                                }}
                            >
                                <img
                                    ref={imgRef}
                                    src={selectedImages[selectedIndex]?.image_url}
                                    className="max-w-none max-h-none select-none block"
                                    draggable={false}
                                    onLoad={() => setImgLoaded(true)}
                                />

                                {/* overlay */}
                                {selectedIndex !== null && selectedImages[selectedIndex]?.position && (() => {
                                    const { left, top, x: width, y: height } = selectedImages[selectedIndex].position;

                                    const sLeft = (left);
                                    const sTop = (top);
                                    const sWidth = (width);
                                    const sHeight = (height);

                                    return (
                                        <>
                                            {/* TOP */}
                                            <div
                                                className="absolute left-0 top-0 w-full bg-gray-700/60 z-40"
                                                style={{ height: sTop }}
                                            />

                                            {/* BOTTOM */}
                                            <div
                                                className="absolute left-0 bg-gray-700/60 z-40"
                                                style={{
                                                    top: sTop + sHeight,
                                                    height: `calc(100% - ${sTop + sHeight}px)`,
                                                    width: "100%",
                                                }}
                                            />

                                            {/* LEFT */}
                                            <div
                                                className="absolute left-0 bg-gray-700/60 z-40"
                                                style={{
                                                    top: sTop,
                                                    width: sLeft,
                                                    height: sHeight,
                                                }}
                                            />

                                            {/* RIGHT */}
                                            <div
                                                className="absolute bg-gray-700/60 z-40"
                                                style={{
                                                    top: sTop,
                                                    left: sLeft + sWidth,
                                                    width: `calc(100% - ${sLeft + sWidth}px)`,
                                                    height: sHeight,
                                                }}
                                            />
                                        </>
                                    );
                                })()}

                                {/* crop */}
                                {selectedIndex !== null && selectedImages[selectedIndex]?.position && (
                                    <div
                                        className="absolute border-4 border-dashed border-red-500 z-50"
                                        style={{
                                            left: (selectedImages[selectedIndex].position.left),
                                            top: (selectedImages[selectedIndex].position.top),
                                            width: (selectedImages[selectedIndex].position.x),
                                            height: (selectedImages[selectedIndex].position.y),
                                            // transform: `rotate(${rotation}deg)`
                                        }}
                                        onMouseDown={(e) => handleDragStart(e, selectedIndex)}
                                    >
                                        {/* GÓC */}
                                        <div className="handle tl" style={{ cursor: getCursor("nw", rotation) }} onMouseDown={e => handleResizeStart(e, selectedIndex, "nw")} />
                                        <div className="handle tr" style={{ cursor: getCursor("ne", rotation) }} onMouseDown={e => handleResizeStart(e, selectedIndex, "ne")} />
                                        <div className="handle bl" style={{ cursor: getCursor("sw", rotation) }} onMouseDown={e => handleResizeStart(e, selectedIndex, "sw")} />
                                        <div className="handle br" style={{ cursor: getCursor("se", rotation) }} onMouseDown={e => handleResizeStart(e, selectedIndex, "se")} />

                                        {/* CẠNH */}
                                        <div className="edge top" style={{ cursor: getCursor("n", rotation) }} onMouseDown={e => handleResizeStart(e, selectedIndex, "n")} />
                                        <div className="edge bottom" style={{ cursor: getCursor("s", rotation) }} onMouseDown={e => handleResizeStart(e, selectedIndex, "s")} />
                                        <div className="edge left" style={{ cursor: getCursor("w", rotation) }} onMouseDown={e => handleResizeStart(e, selectedIndex, "w")} />
                                        <div className="edge right" style={{ cursor: getCursor("e", rotation) }} onMouseDown={e => handleResizeStart(e, selectedIndex, "e")} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* scale  */}
                        <div className="mt-4 flex flex-col items-center gap-2 text-white">
                            <p className="ml-2 text-2xl">
                                {Math.round(userScale * 100)}%
                            </p>
                            <div className="flex gap-4 items-center w-full justify-center">
                                <button
                                    type="button"
                                    onClick={decreaseScale}
                                    className="text-3xl font-bold hover:opacity-70 select-none leading-none"
                                >
                                    −
                                </button>

                                <input
                                    type="range"
                                    min={MIN_SCALE}
                                    max={MAX_SCALE}
                                    step={0.01}
                                    value={userScale}
                                    onChange={(e) => setUserScale(Number(e.target.value))}
                                    className="w-full max-w-[20rem] accent-[#046DB3] cursor-pointer bg-white h-[1px]"
                                />

                                <button
                                    type="button"
                                    onClick={increaseScale}
                                    className="text-3xl font-bold hover:opacity-70 select-none leading-none"
                                >
                                    +
                                </button>
                            </div>
                        </div>

                        <div className="flex justify-between gap-5 text-white font-meidum mt-8 items-start flex-col md:flex-row">
                            <div className="flex gap-5 items-center flex-wrap order-0">
                                <p className="">Số điểm ảnh: 11.8 triệu điểm ảnh</p>
                                <button className="bg-[#01cc00] rounded-full py-1 px-3">Sống động</button>
                            </div>
                            <div className="flex gap-3 items-center -order-1 md:order-1">
                                <p>Xoay ảnh</p>
                                <button
                                    onClick={() => {
                                        setRotation(prev => (prev + 90) % 360);
                                        setUserScale(1);
                                    }}
                                    className="rounded-md bg-white p-2 md:w-10 md:h-10 w-14 h-14">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#1f1f1f">
                                        <path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <div className="flex justify-center gap-8 mt-12 font-bold text-center">
                            <button
                                onClick={() => { setIsCropOpen(false); setSelectedIndex(null) }}
                                className="bg-gray-200 px-6 py-3 rounded min-w-[15rem]"
                            >
                                Hủy
                            </button>
                            <button
                                onClick={handleCrop}
                                className="bg-[#046DB3] text-white px-6 py-3 rounded min-w-[15rem]"
                            >
                                Xác nhận
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {optionProduct && selectedIndex !== null && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                    <div className="bg-white px-6 py-8 rounded-lg max-w-[70rem] w-[96%] block">
                        <h3 className="font-bold text-center text-3xl mb-12">Chọn phong cách in</h3>
                        {activeOption == 1 && (
                            <>
                                <div className="grid grid-cols-[repeat(auto-fill,minmax(20rem,1fr))] gap-6">
                                    {loadingProduct ? (
                                        <div className="col-span-full">
                                            <LoadingData />
                                        </div>
                                    ) : product.length === 0 ? (
                                        <p className="col-span-full text-center text-gray-500">
                                            Không có sản phẩm
                                        </p>
                                    ) : (
                                        product.map((item) => (
                                            <div
                                                key={item.id}
                                                onClick={() => handleProductDetail(item.id)}
                                                className={`
                                                    border rounded-xl p-4 flex flex-col justify-between 
                                                    cursor-pointer duration-200 hover:bg-[#E6F0F7]
                                                    ${activeProductId === item.id ? 'border-[#4C8FF3] bg-[#E6F0F7] hover:opacity-70' : ''}
                                                `}
                                            >
                                                <div>
                                                    <p className="text-center">{item.product_name}</p>

                                                    <div className="mt-4 flex flex-col gap-3">
                                                        <div className="flex gap-4">
                                                            <p className="text-[1.4rem]">Các màu sắc:</p>

                                                            <div className="flex flex-col gap-1">
                                                                {item.colors.map((color) => (
                                                                    <div key={color.id} className="text-[1.4rem] flex gap-4 items-center justify-between">
                                                                        <p>{color.color_name}</p>
                                                                        <span
                                                                            className="block w-6 h-6 rounded-full"
                                                                            style={{ backgroundColor: color.color_code }}
                                                                        ></span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div className="flex gap-4">
                                                            <p className="text-[1.4rem]">Các loại khung:</p>

                                                            <div className="flex flex-col gap-1">
                                                                {item.frames.map((frame) => (
                                                                    <div key={frame.id} className="text-[1.4rem] flex gap-4 items-center justify-between">
                                                                        <p>{frame.frame_name}</p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div className="flex gap-4">
                                                            <p className="text-[1.4rem]">Các loại kích thước:</p>

                                                            <div className="flex flex-col gap-1">
                                                                {item.print_paper_sizes.map((print_paper_size) => (
                                                                    <div key={print_paper_size.id} className="text-2xl flex gap-4 items-center justify-between">
                                                                        <p>{print_paper_size.print_paper_size}</p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <p className="text-[1.4rem] mt-5 italic text-[#046DB3] text-right">Xem chi tiết</p> */}
                                            </div>
                                        ))
                                    )}

                                </div>

                                <button
                                    onClick={() => { setOptionProduct(false); setSelectedIndex(null) }}
                                    className="bg-gray-200 px-6 py-3 rounded w-[15rem] mt-8 ml-auto flex justify-center"
                                >
                                    Đóng
                                </button>
                            </>
                        )}

                        {activeOption == 2 && (
                            <div>
                                <div className="">
                                    {loadingProductDetail ? (
                                        <div className="">
                                            <LoadingData />
                                        </div>
                                    ) : (
                                        productDetail.map((item) => (
                                            <div key={item.id}>
                                                <div>
                                                    <p className="font-medium">{item.product_name}</p>

                                                    <div className="mt-4 flex flex-col gap-6">
                                                        <div className="flex gap-2 flex-col">
                                                            <p className="text-[1.5rem]">Các màu sắc:</p>

                                                            <div className="flex gap-4 flex-wrap">
                                                                {item.colors.map((color) => (
                                                                    <div key={color.id}
                                                                        onClick={() => {
                                                                            setSelectColorId(color.id);
                                                                            setSelectedColor(color);
                                                                        }}
                                                                        className={`
                                                                            text-[1.4rem] flex gap-2 flex-col 
                                                                            border p-4 rounded-lg w-fit cursor-pointer hover:bg-[#E6F0F7] duration-200
                                                                            ${selectColorId === color.id ? 'border-[#4C8FF3] bg-[#E6F0F7] hover:opacity-70' : ''}
                                                                        `}
                                                                    >
                                                                        <div className="flex items-center gap-4">
                                                                            <p>{color.color_name}</p>
                                                                            <span
                                                                                className="block w-6 h-6 rounded-full"
                                                                                style={{ backgroundColor: color.color_code }}
                                                                            ></span>
                                                                        </div>
                                                                        <p>Mã màu: {color.color_code}</p>
                                                                        <p>
                                                                            Đơn giá:{' '}
                                                                            {formatVND(color.price)}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div className="flex gap-2 flex-col">
                                                            <p className="text-[1.5rem]">Các loại khung:</p>

                                                            <div className="flex gap-4 flex-wrap">
                                                                {item.frames.map((frame) => (
                                                                    <div key={frame.id}
                                                                        onClick={() => {
                                                                            setSelectFrameId(frame.id);
                                                                            setSelectedFrame(frame);
                                                                        }}
                                                                        className={`
                                                                            text-[1.4rem] flex gap-2 flex-col 
                                                                            border p-4 rounded-lg w-fit cursor-pointer hover:bg-[#E6F0F7] duration-200
                                                                            ${selectFrameId === frame.id ? 'border-[#4C8FF3] bg-[#E6F0F7] hover:opacity-70' : ''}
                                                                        `}
                                                                    >
                                                                        <div className="flex items-center gap-4">
                                                                            <p>{frame.frame_name}</p>
                                                                        </div>
                                                                        <p>
                                                                            Đơn giá:{' '}
                                                                            {formatVND(frame.price)}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        <div className="flex gap-2 flex-col">
                                                            <p className="text-[1.5rem]">Các loại kích thước:</p>

                                                            <div className="flex gap-4 flex-wrap">
                                                                {item.print_paper_sizes.map((print_paper_size) => (
                                                                    <div key={print_paper_size.id}
                                                                        onClick={() => {
                                                                            setSelectSizeId(print_paper_size.id);
                                                                            setSelectedSize(print_paper_size);
                                                                        }}
                                                                        className={`
                                                                            text-[1.4rem] flex gap-2 flex-col 
                                                                            border p-4 rounded-lg w-fit cursor-pointer hover:bg-[#E6F0F7] duration-200
                                                                            ${selectSizeId === print_paper_size.id ? 'border-[#4C8FF3] bg-[#E6F0F7] hover:opacity-70' : ''}
                                                                        `}
                                                                    >
                                                                        <div className="flex items-center gap-4">
                                                                            <p>{print_paper_size.print_paper_size}</p>
                                                                        </div>
                                                                        <p>
                                                                            Đơn giá:{' '}
                                                                            {formatVND(print_paper_size.price)}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <p className="text-[1.4rem] mt-5 italic text-[#046DB3] text-right">Xem chi tiết</p> */}
                                            </div>
                                        ))
                                    )}

                                </div>
                                <div className="flex gap-4 justify-between mt-12 items-center">
                                    <p className="">
                                        Tổng tiền: {formatVND(totalPrice)}
                                    </p>
                                    <div className="flex gap-4">
                                        <button
                                            onClick={() => { setActiveOption(1) }}
                                            className="bg-gray-200 px-6 py-3 rounded w-[15rem] flex justify-center">
                                            Quay lại
                                        </button>
                                        <button
                                            onClick={handleSaveOption}
                                            className="bg-[#046DB3] px-6 py-3 rounded w-[15rem] flex justify-center text-white">
                                            Xác nhận
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            <Footer />

            {loading && (
                <FormLoading loading={loading} />
            )}
        </>

    );
}


export default Cart;